/*
 A generic class used to control common view logic of chat windows: DOM/EP
*/
// import exitPopupMessageTemplate from '../templates/exit_popup/message_template.ejs'
import createMessageTemplateFactory from '../questiontypes/ImportFactories/ImportMessageTemplateFactory'

import epOfficeHoursMessageTemplate from '../templates/office_hours_messages/Rd_Dom/message_template.ejs'
import domOfficeHoursMessageTemplate from '../templates/office_hours_messages/Rd_EP/message_template.ejs'
// import VAChatRestartOverlay from '../templates/dialog_overlays/VAChatRestartOverlay.ejs';
import VideoGreetOverlay from '../templates/dialog_overlays/VideoGreetOverlay.ejs';
import noAgentAvailable from '../templates/dialog_overlays/noAgentOverlay.ejs';


import epPokeMessageTemplate from '../templates/poke_messages/ep_poke_message_template.ejs';
import domPokeMessageTemplate from '../templates/poke_messages/dom_poke_message_template.ejs';

import epPokeOverlayTemplate from '../templates/poke_messages/ep_poke_overlay_template.ejs';
import domPokeOverlayTemplate from '../templates/poke_messages/dom_poke_overlay_template.ejs';

import BaseClass from './BaseClass';
import LiveChatRoom from './LiveChatRoom';
import QuestionTypeRendererExtentions from '../questiontypes/QuestionTypeRendererExtension';
import QuestionTypeVersion from '../questiontypes/QuestionTypeVersion';
import ChatCookieHandler from './chathandlers/ChatCookieHandler';
import WidgetTypes from './enums/WidgetTypes';
import SimpleView from './SimpleView';
import ParticipantIds from './enums/ParticipantIds';
import { arrayObjectIndexOf } from './ChatUtilityFunctions';
import PokeMessageView from '../pokeMessage/PokeMessageView';
import PokeMessagesUIController from '../pokeMessage/PokeMessagesUIController';
import PokeMessageModel from '../pokeMessage/PokeMessageModel';
import GlobalVariables from './GlobalVariables';
import cleanInvalidHtml from './hooks/cleanInvalidHtml';
import isMessageCompanyHours from './hooks/isMessageCompanyHours';
import parseCompanyHours from './hooks/parseCompanyHours';
import UserIds from './hooks/UserIds';
import ChatMode from './hooks/ChatMode';
import EmojiUtils from './hooks/EmojiUtils';
import fixedElementToTop from './hooks/fixedElementToTop';
import ManageFocusOnKeyEvents from './hooks/ManageFocusOnKeyEvents';
import ParticipantsChanged from './hooks/ParticipantsChanged';
import TimeTracker from './hooks/TimeTracker';
import PipedMessageHandler from './hooks/PipedMessageHandler';
import WebSmsFormValidator from './hooks/WebSmsFormValidator';
import PhoneOTPHandler from './hooks/PhoneOTPHandler';
import Queue from './hooks/Queue';
import ADACompliant from './hooks/ADACompliant';
import log from './hooks/log';
import { LogLevel, QTGridMessageType, ScriptsQuestionType, SkinInviteType, SystemMessageType, VISITOR_MESSAGE_SOUND, VisitorResponseType } from './enums/Enum';
import checkSpanishLanguage from './hooks/checkSpanishLanguage';
import scrollIntoView from './hooks/scrollIntoView';
import parseTemplate from './hooks/parseTemplate';
import setPlaceholder from './hooks/setPlaceholder';
import TempStorageCache from './hooks/TempStorageCache';
import Browser from './hooks/Browser';
import ServerLog from './hooks/ServerLog';
import decodeHTML from './hooks/decodeHTML';
import removeTextFollowedByColon from './hooks/removeTextFollowedByColon';
import addOptionProperty from './hooks/addOptionProperty';
import googleAnalyticsObjectInit from './hooks/googleAnalyticsObjectInit';
import GetChatID from './hooks/GetChatID';
import getQueryStringValue from './hooks/getQueryStringValue';
import To_ascii from '../../To_ascii';
import shiftUps from './hooks/shiftUps';
import RunAsSoonAs from './hooks/RunAsSoonAs';
import ScriptsQuestionTypeToolTips from './hooks/ScriptsQuestionTypeToolTips';
import ChatStates from './hooks/ChatStates';
import RunAfter from './hooks/RunAfter';
import isEnterKeyPressed from './hooks/isEnterKeyPressed';
import observe from './hooks/observe';
import ApexChatTitle from '../core/hooks/ApexChatTitle';
import Cookies from './hooks/Cookies';
import ChatEvents from './hooks/ChatEvents';
import WidgetStates from './hooks/WidgetStates';
import getCookieValue from './hooks/getCookieValue';
import getStorageAPIValue from './hooks/getStorageAPIValue';
import fromQueryString from './hooks/fromQueryString';
import storageAPIExists from './hooks/storageAPIExists';
import languageTransferRequest from './hooks/languageTransferRequest';
import isAcceptKey from './hooks/isAcceptKey';
import showElement from './hooks/showElement';
import hideElement from './hooks/hideElement';
import removeClass from './hooks/removeClass';
import localstorageAPIExists from './hooks/localstorageAPIExists';
import disableTypingInput from './hooks/disableTypingInput';
import enableTypingInput from './hooks/enableTypingInput';
import logIt from '../../logIt';
import getStyleForIframe from './hooks/getStyleForIframe';
import videojs from 'video.js';
import RunUntil from './hooks/RunUntil';
import Utils from './Utils';
import importEndChatOverlaySheetTemplateFactory from '../questiontypes/ImportFactories/ImportEndChatOverlaySheetTemplateFactory';
import importDesclaimerOverlaySheetTemplateFactory from '../questiontypes/ImportFactories/ImportDesclaimerOverlaySheetTemplateFactory';
import importOptinConsentTemplateFactory from '../questiontypes/ImportFactories/ImportOptinOverlaySheetTemplateFactory';
import ImportPhoneOTPOverlaySheetTemplateFactory from '../questiontypes/ImportFactories/ImportPhoneOTPOverlaySheetTemplateFactory';
import ImportEPTemplateFactory from './imports/ImportEPTemplateFactory';
import AgentImageHandler from './hooks/AgentImageHandler';
import ApplySequenceCssClasses from './hooks/ApplyMessageSequenceCssClasses';
import watchElementChanges from './hooks/elementObserver';
import toggleSendButtonClasses from './hooks/toggleSendButton';
import getUniqueValueArray from './hooks/getUniqeValueArray';
import ImportRestartChatOverlayFactory from '../questiontypes/ImportFactories/ImportRestartChatOverlayFactory';
import SwitchLanguage from './hooks/SwitchLanguage';
import RunAsSoonAsWithDelay from './hooks/RunAsSoonAsWithDelay';
import escapeHTML from './hooks/EscapeHTML';
import { ScriptVisitorResponseStatus } from './enums/Enum'
import getNameMessage from '../core/hooks/getNameMessage';
import TempCache from './enums/TempCache';
import FileUploadProvider from './hooks/FileUploadProvider';
import EventEmitter from './hooks/EventEmitter';

export default class ChatUIController extends BaseClass {
    // The life of counterForQueuedTimers starts in showTypingIndicatorThenDisplayMessage and ends
    // in showTypingIndicatorThenDisplayMessage after onComplete has run; the purpose is to make super fast consecutive None type of messages show with delay by incrementing setTimeOut interval
    // Plz note consecutive None messages don't respect setTimeout based delay in
    // showTypingIndicatorThenDisplayMessage and render all at once; this counter variable is a hack to address this issue
    // for other types of messages, this counter variable has no effect

    constructor(options) {
        let opt = null;
        opt = Object.assign(options, {
            widget: options.objectType,
            apologizeForWaitAfter: 0,
            isRoundedDynamic: true,
            apologizeForWaitMessage: 'Just one moment.',
            chatMode: options.model.chatMode,
            position: options.model.position, // Position.Right
            handlerImageUrl: '/contents/images/agents/amanda.jpg'
        });

        // General Elements :: Those elements which are common in all widget.

        // super(options);
        opt.elements = Object.assign(options.elements, {
            chatLogSelectorPrefix:
                '#apexchat_chatlog_' /* this is prefixed to the id of the chat log to ensure no dupes arrive */
        });

        super(opt);
        const me = this;
        if (typeof ApexChat.ApexChatJquery === 'function') {
            me.$ = ApexChat.ApexChatJquery;
        }
        me.widget = options.widget;
        me.oneTimeSoundSetup = true;
        me.mode = null;
        me.isFirstNotificationRendered = false;
        me.counterForQueuedTimers = 0;
        me.INITIAL_DELAY_AGENT_PICKUP = 0.5 * 1000;
        me.INITIAL_DELAY_PRELOAD_GREETING = 1 * 1000; // # of seconds to wait before greeting
        me.ADAHandler = options.ADAHandler;

        me.preserveChatArray = [];
        me.context = me.options.context;
        me.options.widgetType = me.getContextId();
        me.options.model.aiBotEnabled = me.isTransferredToLiveAgent() ? false : me.options.model.aiBotEnabled
        me.options.aiBotEnabled = me.options.model.aiBotEnabled;
        me.allowSoundFloodingOnNewMesssage = false; // introduced this flag to enable/disable sound flooding on demand
        const removeUnnecessaryCookies = function (args) {
            // JIRA_6537 - Greeting not showing after Refresh Ended Chat's overlay on pop out cases
            // summary: We cant move this code inside PreChat Class as it doesnt exist in case of Popedout windowed chat, Removing the PreChat Message Sent helped the greeting to appear it again.
            ApexChat.storageAPI.Remove(TempCache.PreChat_Message_Sent);
        };

        // When Chat Session Ends, On very next message from Visitor, an overlay mask for starting new chat appears,
        // & visitor starts the chat at this point we need to delete few cookies for PreChat.
        me.subscribe(
            WidgetTypes.ChatRoom + ChatEvents.OnSendMessageFailure,
            removeUnnecessaryCookies
        );
        me.subscribe(WidgetTypes.PreChat + WidgetStates.MessageSent, (args) => {
            if (args.questionType === ScriptsQuestionType.FullText) {
                me.handleFullTextType({ res: args });
            } else {
                me.handleQuestionType(args, true);
            }
        });
        me.subscribe(ChatEvents.onOperatorNotAvailable, () => {
            Cookies.set(TempCache.SHOW_OPERATOR_NOT_FOUND_OVERLAY, true);
            me.showOperatorNotFoundOverlay();
            me.hidePokeMessages(); // clear poke overlay if present on screen
        });
        me.subscribe(ChatEvents.onVideoGreetOverlay, () => {
            me.showVideoGreetOverlay();
            me.hidePokeMessages(); // clear poke overlay if present on screen
        });
        // if (me.mode == WidgetTypes.DOM || me.mode == WidgetTypes.ExitPopup) {
        //    me.initChatRoom();
        // }
        // me.initChatRoom();
        if (
            me.options.model.customVisitorScript &&
            me.options.model.runCustomVisitorScriptAfterSeconds
        ) {
            window.setTimeout(() => {
                try {
                    eval(me.options.model.customVisitorScript);
                } catch (e) {
                    log(me.options.model, LogLevel.Warn);
                }
            }, me.options.model.runCustomVisitorScriptAfterSeconds * 1000);
        }
        me.currentText = [];
        if (
            me.options.model.skinInviteType !== SkinInviteType.Image &&
            me.options.model.isOpenForBusiness === false
        ) {
            me.$('.livechat_videochat', me.context).remove();
        }
        if (
            me.options.model.chatMode == ChatMode.DOM &&
            me.options.model.invitationWidgetStyleCustom.indexOf('IsChevronStyleDOM') !== -1
        ) {
            if (
                me.options.model.invitationWidgetStyleCustom.indexOf('IsChevronBOXStyleDOM') !== -1
            ) {
                me.$(`#${me.mobileDOM_ChevronChatArrow}`, me.context)
                    .addClass('apexchat-icon-down-open apexchat-icon-white-13')
                    .removeClass('apexchat-icon-angle-double-down apexchat_icon_white');
            } else {
                me.$(`#${me.mobileDOM_ChevronChatArrow}`, me.context)
                    .addClass('apexchat-icon-angle-double-down apexchat_icon_white')
                    .removeClass('apexchat-icon-down-open apexchat-icon-white-13');
            }
        }
        if (me.options.model.chatMode == ChatMode.DOM) {
            if (
                /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                !window.MSStream &&
                me.options.model.chatMode == ChatMode.DOM
            ) {
                me.$('#apexchat_chatMsg_textbox', me.context).blur(() => {
                    me.reposition.bind2(me);
                });
            }
        }
        me.$('#livechat_send_message_button_new_dom', me.context).click(me.sendMessage.bind2(me));
        if (me.options.model.chatMode == ChatMode.DOM) {
            me.repositionFn = me.reposition.bind2(me);
        } else {
            me.repositionFn = me.syncSize.bind2(me);
        }
        me.$(window).bind('resize orientationchange', me.repositionFn);
        // do not show the auto greet message if operators enabled as then we will see duplicate greetings- first from default and then from the real operator
        const isDOM = getQueryStringValue('initiatedBy') == '';
        const isEPConnected = getQueryStringValue('isEPConnected') == 'true';
        // [ExitPopup]: If Popout from exit popup then greeting message will not show. me.getQueryStringValue("initiatedBy") != "ExitPopup" window.opener.ApexChat.ExitPopup == undefined || !window.opener.ApexChat.ExitPopup.isConnectionEstablished)
        // window.setTimeout(function () {

        // }, 1000);
        me.subscribe(ChatEvents.OnMessageArrived, (args) => {
            me.onMessageArrived(args.m, args.initialLoad, args.index, args.cb);
        });
        me.subscribe(ChatEvents.OnTypingArrived, (args) => {
            me.onTypingArrived(args);
        });
        me.subscribe(ChatEvents.OnChatJoinFailure, (args) => {
            me.onChatJoinFailure(args);
        });
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnMessageArrived, (args) => {
            me.onMessageArrived(args.m, args.initialLoad, args.index, args.cb);
        });
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.ChatIdleOut, (args) => {
            me.endChat();
        });
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnSMSChatTransferring, (args) => {
            me.renderUIOnChatTransfer(args);
        });
        me.subscribe(ChatEvents.OnHistoryStartLoading, (args) => {
            me.hideChatLog();
        });

        me.subscribe(ChatEvents.OnHistoryLoadedCompletely, (args) => {
            me.showChatLog();
        });
        me.subscribe(ChatEvents.OnStopWaiting, (args) => {
            me.stopWaiting();
        });
        me.subscribe(
            WidgetTypes.ChatRoom + ChatEvents.OnParticipantsChanged,
            (participants) => {
                me.onParticipantsChanged(participants);
            }
        );
        me.subscribe(ChatEvents.OnHideWaitingIndicator, (participants) => {
            me.HideWaitingIndicator(participants);
        });
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnTypingArrived, (args) => {
            me.onTypingArrived(args);
        });
        me.subscribe(ChatEvents.OnCallStatusArrived, (args) => {
            me.onCallStatusArrived(args);
        });
        me.subscribe(ChatEvents.OnPredefinedPokeMessage, (args) => {
            me.preserveChatArray.push({
                index: args.index,
                predefinedMsgs: args.msg.text,
                agentParticipantId: ParticipantIds.pokeMessage,
                participantDisplayName: me.options.model.agentName,
                userId: ParticipantIds.pokeMessage,
                isPredefinedResponse: true
            });
            me.showPokeMessages(args.msg); // show a poke message 1-by-1 after EP predefined messages have appeared
        });
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnChatEnded, () => {
            me.onChatEnded();
        });
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnSendMessageSuccess, (args) => {
            me.onMessageArrived(args, false);
        });
        me.subscribe(
            WidgetTypes.DOMUIController + ChatEvents.OnTransferRequested,
            (args) => {
                me.hidePokeMessages(); // clear poke overlay if present on screen
                if (me.chatTransfer) {
                    const chatId = getStorageAPIValue(TempCache.CHAT_ID_COOKIE) || 0;
                    logIt(`TC::transfer chat requested:${chatId}`);
                    const data = {
                        message: 'Chat Transfer requested by the visitor',
                        isSMS: false,
                        chatId: me.getChatId()
                    };
                    me.chatTransfer.Transfer(GlobalVariables.LiveChatServiceUrl, me.$.ajax, data, 'true');
                }
            }
        );
        me.subscribe(WidgetTypes.DOMUIController + ChatEvents.OnChatRestart, (args) => {
            me.hidePokeMessages(); // clear poke overlay if present on screen
            me.showChatRestartOverlay();
        });
        me.subscribe(WidgetTypes.EPUIController + ChatEvents.OnChatRestart, (args) => {
            me.hidePokeMessages(); // clear poke overlay if present on screen
            me.showChatRestartOverlay();
        });
        me.subscribe(
            WidgetTypes.EPUIController + ChatEvents.OnTransferRequested,
            (args) => {
                me.hidePokeMessages(); // clear poke overlay if present on screen
                if (me.chatTransfer) {
                    const chatId = getStorageAPIValue(TempCache.CHAT_ID_COOKIE) || 0;
                    logIt(`TC::transfer chat requested:${chatId}`);
                    const data = {
                        message: 'Chat Transfer requested by the visitor',
                        isSMS: false,
                        chatId
                    };
                    me.chatTransfer.Transfer(GlobalVariables.LiveChatServiceUrl, me.$.ajax, data, 'true');
                }
            }
        );
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnSendMessageFailure, (args) => {
            if (
                (args && args.getErrorCode() && args.getErrorCode() == -1) ||
                me.room.webSyncClient.getIsConnected() == false && !me.options.chatEnded
            ) {
                // condition when server is down or chat is not ended properly
                return; // overlay is not shown when chat is not necessarily end
            }
            if (me.widget == WidgetTypes.DOMUIController) {
                // me.QTRendererExt && me.QTRendererExt.setLastFullText();//keep the last FT text in it (if present in current session) for resending attempt
                me.showChatEndedNotificationBar();
            } else if (me.widget == WidgetTypes.EPUIController) {
                me.showChatEndedNotificationEP();
            }
        });
        me.subscribe(
            WidgetTypes.PokeMessagesOverLay + ChatEvents.OnPokeMessageArrived,
            (args) => {
                if (
                    me.state.getStateValue(WidgetTypes.DOMUIController) ==
                    ChatEvents.OnChatRestart
                ) {
                    return; // no poke, if visitor has initiated chat restart
                }
                if (args.m && args.m.isPredefinedResponse) {
                    // when EP predefined message response there is no need to show poke messages
                    return;
                }
                me.showPokeMessages(args.m);
            }
        );
        me.subscribe(ChatEvents.OnChatOptInConsentAccepted, (args) => {
            me.publishOptInSelection(args);
        });

        me.subscribe(ChatEvents.OnChatOptInConsentRejected, (args) => {
            me.publishOptInSelection(args);
        });

        me.subscribe(
            ChatEvents.OnChatOptInConsentAcceptedButNumberChangeRequested,
            (args) => {
                me.publishOptInSelection(args);
            }
        );
        me.subscribe(ChatEvents.OnChatDisclaimerAccepted, (args) => {
            me.publishDisclaimerSelection(args);
        });
        me.subscribe(ChatEvents.OnChatDisclaimerRejected, (args) => {
            me.publishDisclaimerSelection(args);
        });
        me.subscribe(ChatEvents.OnWebToSmsRejected, function (args) {
            me.publishConvertToSMSRejection(args);
        });
        me.subscribe(WidgetTypes.PokeMessagesOverLay + WidgetStates.Hidden, (args) => {
            me.hidePokeMessages();
        });

        if (
            me.isPageRefreshed() &&
            me.state.getStateValue(WidgetTypes.DOMUIController) ===
            ChatEvents.OnChatRestart
        ) {
            me.hidePokeMessages(); // poke overlay should also be re-reset
            me.showChatRestartOverlay();
            return;
        }
        if (
            me.isPageRefreshed() &&
            me.state.getStateValue(WidgetTypes.EPUIController) === ChatEvents.OnChatRestart
        ) {
            me.hidePokeMessages(); // clear poke overlay if present on screen
            me.showChatRestartOverlay();
            return;
        }

        me.state.changeState({ toState: ChatStates.UIRendered });
        me.askConfirmation = function (options) {
            var message, flag, callback, result;
            if (!options.message) {
                console.error('message is mandatory!');
                return;
            }
            if (!options.callback) {
                console.error('callback is mandatory!');
                return;
            }
            message = options.message;
            //console.log('askConfirmation running');
            flag = options.flag;
            callback = options.callback || false;
            if (flag === undefined || flag === true) {
                result = window.confirm(message);
                if (result) {
                    callback();
                    //console.log('askConfirmation callback invoked');
                }
            } else {
                callback();
                //console.log('askConfirmation callback invoked');
            }
        };

        if (me.options.elements.messagesContainerSelector && me.$) {
            const messagesContainerSelector = me.$(me.options.elements.messagesContainerSelector, me.context);
            // different messages take variable time to render
            // so that we have to wathc the message container for changes
            // then we have added the sequence css classess to the msg elements
            if (!messagesContainerSelector.length) return;
            watchElementChanges(messagesContainerSelector[0], () => ApplySequenceCssClasses(me));
        }

        this.fileUploadEmitter = new EventEmitter();

        if (!this.fileUploader) {
            this.fileUploader = new FileUploadProvider({
                DOM: this.context,
                emitter: this.fileUploadEmitter,
            });
        }
        RunAsSoonAs(function () {
            if (me.fileUploadTrigger) me.fileUploadTrigger.addEventListener('click', () => {
                me.handleAttachmentButtonClicked();
            })
        }, function () {
            me.fileUploadTrigger = me.context.getElementById('livechat_send_attachments_button');
            return !!me.fileUploadTrigger;
        });

    }
    publishConvertToSMSRejection(args) {
        var me = this;
        var chatId = me.room.chatId || me.options.chatId || getCookieValue('livechat_chat_id');
        me.room.webSyncClient.publish({
            retries: 3,
            channel: '/chatroom/' + chatId + '/rejectconverttosms',
            data: args,
            onSuccess: function (args) {
                // nothing
            }
        });
    }
    publishDisclaimerSelection(args) {
        const me = this;
        const { chatId } = args;
        if (!chatId) {
            return;
        }
        me.room.webSyncClient.publish({
            retries: 3,
            channel: `/chatroom/${chatId}/disclaimer`,
            data: args,
            onSuccess(args) {
                // nothing
            }
        });
    }

    publishOptInSelection(args) {
        const me = this;
        const chatId =
            me.room.chatId || me.options.chatId || getCookieValue('livechat_chat_id');
        me.room.webSyncClient.publish({
            retries: 3,
            channel: `/chatroom/${chatId}/optinconsent`,
            data: args,
            onSuccess(args) {
                // nothing
            }
        });
    }

    bind() {
        const me = this;
        const clickSource = me.$(me.options.elements.clickSourceId, me.context);
        if (clickSource) {
            observe(clickSource, 'click', me.clickSourceClick.bind2(me));
        }
        me.container = me.context.querySelector(me.options.elements.containerSelector);
        me.messageInput = me.context.querySelector(me.options.elements.textboxSelector);
        me.autoCompleteInput = me.context.querySelector('#txtAutocompleteInput');
        me.messageInputContainer = me.context.querySelector(me.options.elements.inputContainerSelector);
        me.handlerImageSelector = me.context.querySelector(me.options.elements.handlerImageSelector);
        me.participantsSelector = me.context.querySelectorAll(me.options.elements.participantsSelector);
        me.minimizeButton = me.context.querySelector(me.options.elements.minimizeSelector);
        me.popoutButton = me.context.querySelector(me.options.elements.popoutSelector);
        me.closeButton = me.context.querySelector(me.options.elements.closeSelector);
        me.clickButton = me.context.querySelector(me.options.elements.clickSelector);
        me.messagesContainer = me.context.querySelector(me.options.elements.messagesContainerSelector);
        me.participantsContainer = me.context.querySelectorAll(me.options.elements.participantsSelector)[0];
        me.introContainer = me.context.querySelector(me.options.elements.introSelector);
        me.emoticonsArea = me.context.querySelector(me.options.elements.emoticonsAreaSelector);
        me.emoticonsButton = me.context.querySelector('.livechat_emoticons_area'); // this should now work for all chat windows
        me.multiLanguage_dropdown_wrapper = me.context.querySelector(
            me.options.elements.multiLanguage_dropdown_wrapperSelector
        );
        me.scroller = me.$(me.options.elements.scrollerSelector, me.context);
        me.typingIndicator = me.$(me.options.elements.typingIndicatorSelector, me.context);
        me.headerDropdown = me.context.querySelector('#apexchat_header_dropdown');
        me.actionMenu = me.$(me.options.elements.actionMenuSelector, me.context);
        me.restartVAChatActionMenuItem = me.context.querySelector(
            me.options.elements.restartVAChatSelector

        );
        me.popoutActionMenuItem = me.context.querySelector(me.options.elements.popoutSelector);
        me.transferChatActionMenuItem = me.context.querySelector(me.options.elements.transferChatSelector);
        me.volumeMuteActionMenuItem = me.context.querySelector(me.options.elements.volumeMuteUnmute);
        me.minimizeButton?.addEventListener('click', me.minimize.bind2(me), false);
        me.popoutButton?.addEventListener('click', me.popOut.bind2(me));
        me.closeButton?.addEventListener('click', me.end.bind2(me));
        me.$(me.clickButton, me.context).bind('click', () => {
            const autoComplete = me.$(me.autoCompleteInput).is(':visible') ? me.$(me.autoCompleteInput) : null;
            me.sendMessage(autoComplete);
        });
        // Sound Controls
        me.soundControl = me.$(me.options.elements.soundControl, me.context);
        me.soundMute = me.$(me.options.elements.soundMute, me.context);
        me.soundUnmute = me.$(me.options.elements.soundUnmute, me.context);

        // bottom sheet for langauge
        me.languageBottomSheet = me.$('.open_bottom_sheet', me.context);
        me.smsBottomSheet = me.$('.open_sms_bottom_sheet', me.context);
        // ChevronStyle DOM Elements
        me.mobileDOM_ChevronChatArrow = me.$(
            me.options.elements.mobileDOM_ChevronChatArrow,
            me.context
        );
        // change checkbox selection when visitor click on non textable area -- CHAT-4520
        me.$(me.context).on(
            'click',
            '.apexchat_question_type_all_that_apply_checkbox',
            function (sender) {
                me.$(this)
                    .children(':checkbox')
                    .prop('checked', !me.$(this).children(':checkbox').is(':checked'));
            }
        );
        me.$(me.messageInput, me.context)
            .keydown((e) => {
                me.onMessageTyping(e, me.messageInput);
            })
            .focus(function () {
                me.$(this).removeClass('blur');
            })
            .blur(function () {
                me.$(this).addClass('blur');
            })
            .on('input', (e) => {
                const $txt = me.$(me.messageInput, me.context);
                me.sendButtonDisableOrEnableForATA($txt);
            });
        me.$(me.autoCompleteInput, me.context)
            .on('keydown', (e) => {
                me.onMessageTyping(e, me.autoCompleteInput);
            })
            .focus(function () {
                me.$(this).removeClass('blur');
            })
            .blur(function () {
                me.$(this).addClass('blur');
            });
        // to bring focus on drop down, restartchat and popout buttons
        ManageFocusOnKeyEvents(me.headerDropdown);
        ManageFocusOnKeyEvents(me.restartVAChatActionMenuItem);
        ManageFocusOnKeyEvents(me.popoutActionMenuItem);
        ManageFocusOnKeyEvents(me.transferChatActionMenuItem);
        ManageFocusOnKeyEvents(me.volumeMuteActionMenuItem);
        // header dropdown menu toggle function
        me.$(me.headerDropdown).on('keyup click', (e) => {
            // check if button already not selected then do the action
            e.stopPropagation();
            if (e.type == 'click' || (e.type == 'keyup' && isAcceptKey(e))) {
                // check for mouse click or tab and enter key
                me.actionMenu.toggle(); // When the user clicks on the header dropdown, the menu item is displayed
            }
        });
        // header dropdown close menu when clicked outside the menu area.
        me.$('#apexchat', me.context).on('click', () => {
            const element = me.actionMenu;
            element.hide();
        });
        me._countDownInterval = window.setInterval(me.updateCountdown.bind2(me), 1000);
        const chatHeaderTemplate =
            me.options.chatModel &&
            me.options.chatModel.chatHeaderTemplate &&
            parseTemplate(me.options.chatModel.chatHeaderTemplate, me.options.model);
        const initialChat = chatHeaderTemplate
            ? chatHeaderTemplate
            : checkSpanishLanguage(me.options)
                ? 'Chateando con ' + me.options.model.agentName
                : 'Chatting with ' + me.options.model.agentName;

        me.$(me.introContainer, me.context).html(initialChat);
        if (checkSpanishLanguage(me.options)) {
            setPlaceholder(
                me.$('#apexchat_rd_msg_box', me.context),
                ScriptsQuestionTypeToolTips.Spa.Text
            );
        }
        // inserting emojis img tags inside a div with the help of div css name.
        // Emoticon WORK - start - // inserting emojis img tags inside a div with the help of div css name.
        if (me.emoticonsArea) {
            // this check avoids inserting emojis twice.
            const emoticonContentContainer = me.$(me.emoticonsArea, me.context);
            if (emoticonContentContainer.children().length == 0) {
                const emojisList = new EmojiUtils().createEmojiList(); // ref. CHAT-3836
                if (emojisList.length > 0) {
                    for (let e = 0; e < emojisList.length; e++) {
                        emoticonContentContainer.append(emojisList[e]);
                    }
                }
            }

            if (me.emoticonsArea && me.emoticonsArea.children.length > 0) {
                const children = me.emoticonsArea.children;

                for (let i = 0; i < children.length; i++) {
                    children[i].addEventListener('click', function (e) {
                        me.clickEmojis(e);
                    });
                }
            }

            if (me.ADAHandler) {
                me.ADAHandler(me.emoticonsButton, () => {
                    me.openEmoticons();
                });
            }
        }
        // Emoticon WORK - end
        let lastValue = '';
        // check for updates every second in the visitor response area
        const $txt = me.messageInput;
        RunAsSoonAs(
            () => {
                me.dmp = new diff_match_patch();
            },
            () => typeof diff_match_patch !== 'undefined'
        );
        setInterval(() => {
            try {
                if (me.room) {
                    const textValue = $txt.value;
                    if (textValue == $txt.getAttribute('title')) {
                        return;
                    }
                    if (textValue != lastValue) {
                        const text1 = lastValue;
                        const text2 = textValue
                        lastValue = textValue;
                        const diff = me.dmp.diff_main(text1, text2, true);
                        if (diff.length > 2) {
                            me.dmp.diff_cleanupSemantic(diff);
                        }
                        const patch_list = me.dmp.patch_make(text1, text2, diff);
                        const patch_text = me.dmp.patch_toText(patch_list);
                        me.room.sendVisitorRealtimeTyping(patch_text, false);
                    }
                }
            } catch (e) {
                console.log(e);
            }
        }, 1000);
        // JIRA_2908 - START - Recent response should appear
        if (me.options.model.isMobile) {
            me.$(me.options.model.textboxSelector, me.context).focus(() => {
                window.setTimeout(() => {
                    me.autoScroll(); // specifically for mobile devices.
                }, 600); // delaying 600ms because keyboard takes time to appear without delay autoscroll was not working before keyboard appearance
            });
        } // JIRA_2908 - END
        // hide the disclaimer if it's empty
        me.$(`${me.options.model.disclaimerSelector}:empty`, me.context).hide();
        // JIRA_2905 - START - Sound indicator for incoming messages
        // summary: This is the function which hide/shows the sound icon button + It also binds their click events.
        // bind Sound Controls
        if (!storageAPIExists(TempCache.CHAT_SOUND_ENABLED)) {
            ApexChat.storageAPI.Store(TempCache.CHAT_SOUND_ENABLED, true);
        }
        if (getStorageAPIValue(TempCache.CHAT_SOUND_ENABLED) == 'false') {
            me.soundMute.hide();
            me.soundUnmute.show();
        }
        me.$(me.soundControl, me.context).click(() => {
            if (getStorageAPIValue(TempCache.CHAT_SOUND_ENABLED) == 'true') {
                me.soundMute.hide();
                me.soundUnmute.show();
                ApexChat.storageAPI.Store(TempCache.CHAT_SOUND_ENABLED, false);
            } else {
                me.soundMute.show();
                me.soundUnmute.hide();
                ApexChat.storageAPI.Store(TempCache.CHAT_SOUND_ENABLED, true);
            }
        });
        // Capturing User's Touch Event For the sake of enabling the Sound Permission on mobile/tablet devices.
        let hasUserGrantedSoundPermission = false;
        me.$('#apexchat', me.context).on('touchstart', () => {
            if (!hasUserGrantedSoundPermission) {
                hasUserGrantedSoundPermission = true;
                const soundName =
                    Cookies.get(VISITOR_MESSAGE_SOUND.name) ||
                    VISITOR_MESSAGE_SOUND.tune;
                me.playSound(soundName);
            }
        });
        // JIRA_2905 - END
        // JIRA_2953 - START - display disclaimer above the initial greeting and below header
        // Summary: checking newly added disclaimer if its empty then just hide it.
        if (!me.options.model.headerDisclaimer || me.options.model.headerDisclaimer.trim() == '') {
            // Added .trim() So if someone used 'Blank Spaces' this condition will catch it and will not show the header disclaimer
            me.$('.apexchat_headerdisclaimer', me.context).hide();
        } // JIRA_2953 - END
        setTimeout(() => {
            me.$(me.messageInput, me.context).focus();
            me.$(me.autoCompleteInput, me.context).focus();
        }, 50);
        this.subscribe('chatui-message-arrived', () => {
            if (!me.ADAHandler) {
                return;
            }
            // we can apply custom logic here onMessageArrived
            // logIt('messageArrived');
            const elements = me.$('.apexchat_auto_genned_message_wrapper', me.context);

            for (let i = 0; i < elements.length; i++) {
                me.ADAHandler(elements[i]);
            }
        });
        if (me.ADAHandler) {
            me.applyADAonEmojis(me.ADAHandler); // this should work for all chat windows
        }
    }

    showChatLog() {
        const me = this;
        me.$(me.options.elements.messagesContainerSelector, me.context).show();
        me.autoScroll();
    }

    hideChatLog() {
        const me = this;
        // CHAT - 8646 The input field gets unlocked after a page refresh
        // (DISCARDED) : Preventvisitorresponse area disbale was introduced due to prevent the flikering on textarea
        // incase of refresh. Now noticed that the issue has been resolved and no more producing the flikering effect.

        // me.$.preventVisitorResponseAreaDisabling = true;
        me.$(me.options.elements.messagesContainerSelector, me.context).hide();
        // while loading chat if operation get disruppted due to an error,
        // it will automatically show the chatLog of loaded content after 5seconds
        RunAfter(() => {
            me.showChatLog();
        }, 5000);
    }

    hidePokeMessages() {
        const me = this;
        logIt('destroying poke messages controller, etc....');
        if (me.POKE_MESSAGE_CONTROLLER && me.POKE_MESSAGE_CONTROLLER.view) {
            const overlay = me.context.querySelector(
                me.POKE_MESSAGE_CONTROLLER.view.overLayTargetElementSelector
            );
            removeClass(overlay, me.POKE_MESSAGE_CONTROLLER.view.overlayDisplayClass);
            me.POKE_MESSAGE_CONTROLLER = null; // just destroy this object to make room for next nbrand new one
            const isDisabled = me
                .$(me.messageInputContainer, me.context)
                .find('textarea')
                .prop('disabled');
            if (me.messageInputContainer && me.messageInputContainer.length && !isDisabled) {
                // focus text area
                if (!Browser.isiOS()) {
                    // Do not focus the input in iOs case because keyboard is not showing but reposition function executed
                    // which is producing flickering effect in UI
                    me.$(me.messageInputContainer, me.context).find('textarea').trigger('focus');
                }
            }
        }
    }

    showPokeMessages(m) {
        // popup poke overlay and show poke messages when arrived
        const me = this;
        if (!me.POKE_MESSAGE_CONTROLLER) {
            let overlay_options;
            const is_RD_EP =
                me.widget === WidgetTypes.EPUIController;
            if (me.isEPChatClosed()) {
                return; // no active EP chat, no poke (re-fixed: Bug/CHAT-8678)
            }
            if (is_RD_EP) {
                overlay_options = {
                    context: me.context,

                    identifier: 'apexChat_ep_poke_overlay_container',
                    overLayTargetElementSelector: '#apexChat_ep_poke_overlay_container',
                    overLayTemplate:
                        epPokeOverlayTemplate,

                    messageContainer: 'apexchat_ep_poke_msg_container',
                    messageTargetElementSelector: '#apexchat_ep_poke_msg_container',
                    messageTemplate:
                        epPokeMessageTemplate,
                    btnBackSelector: '#apexChat_ep_poke_btn',
                    overlayDisplayClass: 'apexChat_ep_poke_overlay_show'
                };
            } else {
                // RD DOM?
                overlay_options = {
                    context: me.context,

                    identifier: 'apexChat_poke_overlay_container',
                    overLayTargetElementSelector: '#apexChat_poke_overlay_container',
                    overLayTemplate:
                        domPokeOverlayTemplate,

                    messageContainer: 'apexchat_poke_msg_container',
                    messageTargetElementSelector: '#apexchat_poke_msg_container',
                    messageTemplate:
                        domPokeMessageTemplate,

                    btnBackSelector: '#apexChat_poke_btn',
                    overlayDisplayClass: 'apexChat_poke_overlay_show'
                };
            }
            me.POKE_MESSAGE_CONTROLLER = new PokeMessagesUIController({
                model: new PokeMessageModel({
                    overLayModel: {
                        userResponseText: "Yes, I'm back"
                    }
                }),
                view: new PokeMessageView(overlay_options)
            });
            // me.POKE_MESSAGE_CONTROLLER.show();//trigger the overlay if not shown on top of messages area
        }
        m.msgTimeStamp = m.createdOn.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
        });
        me.POKE_MESSAGE_CONTROLLER.addPokeMessage(m); // which should show/append a new message in the poke message overlay
        if (me.messageInputContainer && me.messageInputContainer.length) {
            // blur text area just in case it in focus
            me.$(me.messageInputContainer, me.context).find('textarea').trigger('blur');
        }
    }

    applyADAonEmojis(handleADA) {
        const me = this;
        const emojiDiv = me.emoticonsArea;
        if (emojiDiv && emojiDiv.length > 0) {
            // TODO: simplify this using jquery later
            const { children } = emojiDiv[0];
            if (children.length > 0) {
                for (let i = 0; i < children.length; i++) {
                    handleADA(children[i], me.clickEmojis.bind2(me), me.closeEmoticons.bind2(me));
                }
            }
        }
    }

    openEmoticons(e) {
        if (this.$(this.emoticonsArea).hasClass('livechat_emoticons_area_content_active')) {
            this.$(this.emoticonsArea).removeClass('livechat_emoticons_area_content_active');
        } else {
            this.$(this.emoticonsArea).addClass('livechat_emoticons_area_content_active');
        }
        // this.$(this.emoticonsArea).css({ display: 'inline', right: 0, bottom: 0 });
    }

    closeEmoticons(e) {
        this.$(this.emoticonsArea).css({ display: 'none' });
    }

    handleFullTextType(options, message) {
        const me = this;
        let res;
        let cb;
        let isSkippable;
        res = options && options.res;
        cb = options && options.cb;
        isSkippable = res && res.isSkipped;

        if (isSkippable === true) {
            me.skipFullTextType(res);
            return;
        }
        // make sure Chat Is Active and In Progress before sending the message to Websync
        if (!me.isChatActive() && !me.QTRendererExt.isLastFullTextValidated) {
            return; // we won't come here ever; just a dbl safety
        }
        const hasVisitorAttachments = !!me.fileUploader?.newValidFiles?.length ?? false;

        if (res && res.chatLogId && hasVisitorAttachments) {
            me.fileUploader?.showTempFilesInMessage(res);
        }
        me.room.sendMessage({
            isForAIBot: ApexChat.options.aiBotEnabled,
            chatMsg: res.msgText,
            isGreeting: res.isGreeting,
            shouldRenderResponseAsText: true,
            questionTypeChatLogIdToBeUpdated: res.questionTypeChatLogIdToBeUpdated,
            questionType: res.questionType || '',
            hasVisitorAttachments,
            async onSuccess(msg) {
                // on success of websync publish
                logIt('FT::publishing FT...');
                if (msg && msg.id && hasVisitorAttachments) {
                    await me.fileUploader?.uploadFiles(msg);
                }
                me.room.publishQuestionTypeResponse(res, cb);
            }
        });
    }

    skipFullTextType(res) {
        const me = this;
        me.room.publishQuestionTypeResponse(res);
    }

    /**
     * simulated predefined message after selection of QT.
     * @param {} msg - Message Object
     */
    simulatePredefinedResponse(msg) {
        const me = this;
        if (!ApexChat.IsShowDisclaimeOverlay && me.options.shouldShowLocationDisclaimer) {
            ApexChat.IsShowDisclaimeOverlay = true;
            me.showDisclaimerOverlay(me.options.locationDisclaimerText);
        }
        if (msg.shouldRenderResponseAsText) {
            // only simulate those message which allow render as text
            me.onMessageArrived({
                id: msg.predefinedMessageId || GlobalVariables.predefinedMessageId, // check the predefined message id exists into the object if not execute old scenario
                userId: ParticipantIds.visitor,
                createdOn: new Date(),
                participantDisplayName: 'Visitor',
                text: msg.msgText,
                allowDupe: false,
                participantId: ParticipantIds.visitor,
                showTime: true // show time for simulated message
            });
            me.isPredefinedResponse = true; // set flag true for upcoming response message.
            me.QTRendererExt.questionTypeRenderer.afterMCSelectionRD(msg); // for MC selection.
            me.postMessage({
                event: ChatEvents.OnTypingArrived,
                value: { indicator: true }
            }); // show typing after simulated message.
        }
    }

    // check chatRoom loaded
    publishedPredefinedMessages(res, isFromPreChat) {
        const me = this;
        me.checkChatRoomLoaded(() => {
            // publish previously rendered messages here.
            me.publishPredefinedMessages((m) => {
                if (
                    !me.hasAnswerInQTChatLogIdToBeUpdated &&
                    m.questionType > ScriptsQuestionType.None
                ) {
                    // when QT time calendar then execute below function
                    if (
                        m.questionType == ScriptsQuestionType.TimeCalendar ||
                        m.questionType == ScriptsQuestionType.Text
                    ) {
                        me.handleQTCommaSepartedRow(m, res, isFromPreChat);
                    } else {
                        me.hasAnswerInQTChatLogIdToBeUpdated = true;
                        res.isSimulatePredefinedMessage = false;
                        res.participantDisplayName =
                            me.options.agentName || me.options.model.agentName;
                        res.agentParticipantId = ParticipantIds.predefined; // CHAT-6370 predefined participantId -4
                        res.userId = UserIds.simulated;
                        res.visitorResponseStatus = ScriptVisitorResponseStatus.Answered;
                        res.visitorSelectedOptions = `[{ "option": "${res.msgText}"}]`;
                        res.chatLogId = m.id;
                        res.isPredefinedResponse = me.isPredefinedResponse || false;
                        res.questionTypeChatLogIdToBeUpdated = m.id;
                        me.handleQuestionType(res, isFromPreChat);
                    }
                }
            });
        });
    }

    handlePredefinedQT(res, isFromPreChat) {
        const me = this;
        // simulate predefined selection without delay.
        if (!res.isSkipped) {
            if (
                res.questionType == ScriptsQuestionType.TimeCalendar ||
                res.questionType == ScriptsQuestionType.Text
            ) {
                if (!me.responseArray) {
                    me.responseArray = new Array(); // create an array object
                    res.predefinedMessageId = GlobalVariables.predefinedMessageId; // simulate first message to assign predefined message id
                } else {
                    res.predefinedMessageId = --GlobalVariables.predefinedMessageId; // to remove duplication predefined message id
                }
                me.responseArray.push(res); // push item in array item and pass it to the function to execute handle question functionality
            }
            me.simulatePredefinedResponse(res);
            if (
                me.firstMsgSent &&
                (res.questionType == ScriptsQuestionType.TimeCalendar ||
                    res.questionType == ScriptsQuestionType.Text)
            ) {
                // when QT is time calendar and first message are render then avoid to run below statement
                return;
            }
        }
        me.firstMsgSent = true;
        // In case of RD EP Predefined msg of QT, the poke message job was not stopping and causing the CHAT-9148
        if (me.pokeMessageJob) {
            // in case of RD EP
            me.pokeMessageJob?.stop(); // after first response, the pokeMessage job for predefinned is over
        }
        me.reInitChatSubscribeForEP = false;
        if (GetChatID(me.options)) {
            // check chatId is created
            me.publishedPredefinedMessages(res, isFromPreChat);
        } else {
            // create room then call back.. recusive
            me.options.execChatStartHandler(() => {
                me.publishedPredefinedMessages(res, isFromPreChat);
            });
        }
    }

    // handle comma separted QTs
    handleQTCommaSepartedRow(m, res, isFromPreChat) {
        const me = this;
        me.responseArray.forEach((option) => {
            setTimeout(() => {
                me.hasAnswerInQTChatLogIdToBeUpdated = true;
                res = option;
                res.isSimulatePredefinedMessage = false;
                res.participantDisplayName = me.options.agentName || me.options.model.agentName;
                res.agentParticipantId = ParticipantIds.predefined; // CHAT-6370 predefined participantId -4
                res.userId = UserIds.simulated;
                res.visitorResponseStatus = ScriptVisitorResponseStatus.Answered;
                res.visitorSelectedOptions = `[{ "option": "${res.msgText}"}]`;
                res.chatLogId = m.id;
                res.isPredefinedResponse = me.isPredefinedResponse || false;
                me.handleQuestionType(res, isFromPreChat);
            }, 500);
        });
    }

    handleQuestionType(res, isFromPreChat) {
        const me = this;
        logIt('handleQuestionType:');
        logIt(res);
        if (res.isSimulatePredefinedMessage) {
            me.handlePredefinedQT(res, isFromPreChat);
            return;
        }
        if ((!res.msgText || (res.msgText.trim && !res.msgText.trim())) && !res.isSkipped) {
            // when msg text is empty we must not send it to server
            return;
        }
        if (!res.isSkipped) {
            if (me.options.botGuid) {
                me.showTyptingIndicatorForAIBot(me);
            }
            me.room.sendMessage({
                chatMsg: res.msgText,
                isGreeting: res.isGreeting,
                shouldRenderResponseAsText: res.shouldRenderResponseAsText,
                questionTypeChatLogIdToBeUpdated: res.questionTypeChatLogIdToBeUpdated,
                isPredefinedResponse: !!res.isPredefinedResponse,
                contactInfo: res.contactInfo || '',
                textContactInfo: res.textContactInfo || '',
                questionType: res.questionType || '',
                timeCalendarOrText: res.timeCalendarOrText || false,
                onSuccess() {
                    // on success of websync publish
                    me.room.publishQuestionTypeResponse(res);
                    // Set the visitor selection of question type
                    if (me.QTRendererExt.questionTypeRenderer.renderer) {
                        res.visitorSelectedOptions = res.answers;
                        res.questionType =
                            me.QTRendererExt.questionTypeRenderer.renderer.model.questionType;
                        res.questionTypeDisplayListForVisitor =
                            me.QTRendererExt.questionTypeRenderer.renderer.model.questionTypeDisplayListForVisitor;
                        res.id = res.chatLogId;
                        me.QTRendererExt.questionTypeRenderer.setVisitorSelection(res);
                        if (me.options && !me.options.enableFullTextLogic) {
                            // check is RD or not
                            me.QTRendererExt.setInstruction(me.getQTPlaceHolder());
                        }
                    }
                    if (isFromPreChat) {
                        setTimeout(() => {
                            me.maximize();
                            if (
                                me.state.getStateValue(WidgetTypes.PreChat) ===
                                WidgetStates.Hidden
                            ) {
                                me.QTRendererExt.questionTypeRenderer.afterSubmit();
                            } else {
                                me.QTRendererExt.questionTypeRenderer.afterSubmit();
                                me.QTRendererExt.questionTypeRenderer.hideAll();
                            }
                            res.isFromPreChat = isFromPreChat;
                            // CHAT-7045 - If DOM minimized & prechat has appeared now agent sends TRUE/FALSE we need to handle the selection, DOM should be able to retain the selection.
                            res.questionType === ScriptsQuestionType.TrueOrFalse &&
                                me.QTRendererExt.questionTypeRenderer.renderSelection(res);
                        }, 100);
                    }
                },
                callback() { } // after sending msg to dashboard do something
            });
        } else {
            // marked, visitor skip that question
            me.room.publishQuestionTypeResponse(res);
        }
    }

    async injectQuestionTypeRenderer() {
        /**
         * questionType rendered to initialize question type when needed.
         */
        const me = this;
        const preloadOptions = ApexChat.preLoadedOptions || me.getPreloadedOptionsStorage();
        if (!me.QTRendererExt) {
            me.QTRendererExt = new QuestionTypeRendererExtentions();
            if (preloadOptions) {
                preloadOptions.aiBotEnabled = ApexChat.options.aiBotEnabled;
            }
            await me.QTRendererExt.initComponent(
                Object.assign(Object.assign(me.options, preloadOptions), {
                    context: me.context,
                    isUpdateSupported: true,
                    sendButton: me.clickButton,
                    messagesContainer: me.messagesContainer,
                    isBottomSheetSupported:
                        (me.widget == WidgetTypes.DOMUIController ||
                            me.widget == WidgetTypes.EPUIController),
                    applyNewDateTime: true,
                    enableFullTextLogic:
                        (me.widget === WidgetTypes.DOMUIController ||
                            me.widget == WidgetTypes.EPUIController), // . CHAT-7137 - We need this FullText Logic for DOM & EP
                    widgetType:
                        me.widget == WidgetTypes.DOMUIController
                            ? WidgetTypes.DOM
                            : WidgetTypes.ExitPopup,
                    inputContainer: me.messageInputContainer

                })
            );
        }
    }

    getPreloadedOptionsStorage() {
        // summary: To get preload options from local storage when ApexChat.preLoadedOptions is not available
        // below scenario is done due to DOM refresh case. It's looses question type template, So we get it from local storage available at first time.
        let preloadedOptionsStorage = null;
        if (
            !ApexChat.preLoadedOptions &&
            localstorageAPIExists('livechat_preloaded_options')
        ) {
            logIt('Inside apexchat_preloaded_options');
            preloadedOptionsStorage = ApexChat.TryParse(
                ApexChat.localStorageAPI.Get('livechat_preloaded_options')
            );
        }
        return preloadedOptionsStorage;
    }

    showChatRestartOverlay() {
        const me = this;
        if (!me.restartOverlayView) {
            // rare scenario
            return;
        }
        const elOverlay = me.restartOverlayView.getContainer();
        if (elOverlay && me.restartOverlayView.isViewRendered()) {
            // view previously rendered? just show it
            me.$(elOverlay, me.context).show();
        } else {
            me.restartOverlayView.render(); // is it v 1st time?
        }
    }

    showVideoGreetOverlay() {
        const me = this;
        const elOverlay = me.videoGreetOverlayView?.getContainer();
        if (elOverlay && me.videoGreetOverlayView.isViewRendered()) {
            // view previously rendered? just show it
            me.$(elOverlay, me.context).show();
        } else {
            me.videoGreetOverlayView.render(); // is it v 1st time?
        }
    }

    isOperatorAvailable(message) {
        const me = this;
        const showOperatorOverlay = Cookies.get(TempCache.SHOW_OPERATOR_NOT_FOUND_OVERLAY);
        if (message.text === ApexChat.operatorNotAvailableMessage) {
            if (me.isPageRefreshed() && showOperatorOverlay === 'false') {
                return true;
            }
            me.showOperatorNotFoundOverlay();
            return true;
        }
        if (showOperatorOverlay === 'true') {
            me.showOperatorNotFoundOverlay();
        }
    }

    isChatTransferredToOperator(m) {
        const me = this;
        if (m.text === ApexChat.chatTransferSuccussMessage) {
            me.postMessage({
                event: ChatEvents.OnChatTransferredToOperator,
                data: m
            });
        }
    }

    showOperatorNotFoundOverlay(m) {
        const me = this;
        if (!me.agentNotFoundOverlayView) {
            // rare scenario
            return;
        }
        const elOverlay = me.agentNotFoundOverlayView.getContainer();
        if (elOverlay && me.agentNotFoundOverlayView.isViewRendered()) {
            // view previously rendered? just show it
            me.$(elOverlay, me.context).show();
        } else {
            me.agentNotFoundOverlayView.render(); // is it v 1st time?
        }
    }

    showChatEndedNotificationBar() {
        var me = this;
        var wrapper = document.createElement('div');
        me.optInConsentTaken = false;
        me.showOverlayWithAction(wrapper, me.getEndChatSessionHtml(wrapper), function () {
            RunAsSoonAs(
                function () {
                    me.$('#apexchat_reinit_chat', me.context).addClass(
                        'apexchat_optin_concent_show'
                    );
                },
                function () {
                    return me.$('#apexchat_reinit_chat', me.context).is(':visible');
                }
            );
            //event binding
            me.context.querySelector('.apexchat_closebtn').addEventListener('click', function () {
                //CHAT-7520 removing overlay from DOM & windowed mode.
                me.hideReInitOverlay('#apexchat_reinit_chat');
                enableTypingInput.bind2(me)(me, me.options.inputContainer); //after reInit chat typing input feild is enabled.
            });
            me.ADAHandler(
                me.context.querySelector('.apexchat_closebtn'),
                me.hideReInitOverlay.bind2(me, '#apexchat_reinit_chat')
            );
            me.ADAHandler(me.context.querySelector('.apexchat_new_chat_start'), function () {
                me.reInitializeChat();
            });
            me.context.querySelector('.apexchat_new_chat_start').addEventListener('click', function () {
                me.reInitializeChat();
            });
        });
    }

    hideReInitOverlay(overlay) {
        const me = this;
        if (overlay) {
            if (me.widget == WidgetTypes.EPUIController) {
                // CHAT-8737 V3 - NonRD: Cross icon of ended chat overlay is not functional
                me.$(overlay, me.context).hide();
                me.$(overlay, me.context).parent().removeClass('livechat_reinit_show')
            } else {
                me.$(overlay, me.context).remove();
                // reset state
                me.state.changeState({
                    toState: ChatStates.UIRendered
                });
            }
        }
    }

    // Re-Initializes chat if chat session ended OR if chat restarted
    reInitializeChat(currentOverlaySelector, headerMessage) {
        const me = this;
        me.$(me.options.elements.transferChatSelector, me.context).show();
        me.$(me.options.elements.actionMenuStartSMSChat, me.context).show();
        me.$(me.options.elements.actionMenuLanguageSwitcher, me.context).show();
        me.messagesContainer?.innerHTML = '';
        me.participantsContainer?.innerHTML = '';
        me.$(currentOverlaySelector || '#apexchat_reinit_chat', me.context).remove();
        me.participantsContainer?.style.display = 'block';
        me.introContainer?.style.display = 'block';
        const initialChat = checkSpanishLanguage(me.options)
            ? `Chateando con ${me.options.model.agentName}`
            : `Chatting with ${me.options.model.agentName}`;
        // me.introContainer?.innerHTML = (headerMessage || initialChat);
        me.introContainer?.innerHTML = initialChat;
        me._countDownInterval = window.setInterval(me.updateCountdown.bind2(me), 1000);
        me.postMessage({
            event: (me.objectType || me.options.objectType) + ChatEvents.OnChatReInit
        });
    }

    getEndChatSessionHtml(wrapperDiv) {
        const divHtml = importEndChatOverlaySheetTemplateFactory()?.restartChatTemplate;
        wrapperDiv.id = 'apexchat_reinit_chat';
        wrapperDiv.className = 'apexchat_overlay apexchat_optin_concent';
        return divHtml;
    }

    getOptInConsentHtml(wrapperDiv, options) {
        const divHtml = importOptinConsentTemplateFactory(options)?.optinConsentTemplate;
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = divHtml;

        if (this.options.companyName) {
            const companyDiv = document.createElement('div');
            companyDiv.style.fontSize = '18px';
            companyDiv.style.color = '#fff';
            companyDiv.style.fontWeight = 'bold';
            companyDiv.innerHTML = this.options.companyName;
            const br1 = document.createElement('br');

            const messageDiv = tempContainer.querySelector('div[style*="font-size: 14px"], div.apexchat_consent_title');
            if (messageDiv && messageDiv.parentNode) {
                if (messageDiv.classList.contains('apexchat_consent_title')) {
                    messageDiv.insertBefore(br1, messageDiv.firstChild);
                    messageDiv.insertBefore(companyDiv, messageDiv.firstChild);
                } else {
                    messageDiv.parentNode.insertBefore(companyDiv, messageDiv);
                    messageDiv.parentNode.insertBefore(br1, messageDiv);
                }
            }
        }

        wrapperDiv.id = 'livechat_opt_in_consent';
        wrapperDiv.className = 'apexchat_overlay apexchat_optin_concent';
        return tempContainer.innerHTML;
    }

    getPhoneOTPHtml(options) {
        const divHtml = ImportPhoneOTPOverlaySheetTemplateFactory(options)?.optinConsentTemplate;
        return divHtml;
    }
    getDisclaimerHtml(wrapperDiv, options) {
        const importedFactory = importDesclaimerOverlaySheetTemplateFactory(options);
        let divHtml = importedFactory?.desclaimerTemplate;
        divHtml += importedFactory?.desclaimerConfirmTemplate;
        wrapperDiv.id = 'livechat_disclaimer_consent';
        wrapperDiv.className = 'apexchat_overlay apexchat_optin_concent';
        return divHtml;
    }

    updateCountdown() {
        const me = this;
        this._ellipses = `${this._ellipses || ''}.`;
        if (this._ellipses.length > 4) {
            this._ellipses = '.';
        }
    }

    clickEmojis(event) {
        console.log(event); // Debugging log
        const me = this;
        const currentTarget = event.currentTarget;

        // Get emoji from its ID
        const emojiCode = currentTarget.id;
        const emoji = new EmojiUtils().toEmoji(emojiCode); // Convert emoji code

        // Function to update input values safely
        function appendEmojiToInput(inputField) {
            if (!inputField) return;

            let val = inputField.value;
            const placeholder = inputField.getAttribute('title');

            // Remove placeholder text if it exists
            if (placeholder && val.includes(placeholder)) {
                val = val.replace(placeholder, '');
            }

            inputField.value = val + emoji; // Append emoji
            toggleSendButtonClasses({ e: { target: { value: inputField.value } }, me });
        }

        // Apply to both input fields
        appendEmojiToInput(me.messageInput);
        appendEmojiToInput(me.autoCompleteInput);

        console.log("Emoji added to both inputs:", emoji);
    }

    hasScrollbar(elem_id) {
        const elem = this.context.getElementById(elem_id);
        if (elem.clientHeight < elem.scrollHeight) {
            return true;
        }
        return false;
    }

    endChat(cb) {
        const me = this;
        ApexChat.AIResponseReceived = true;
        // unsubscribe chatroom channel if exists
        if (me.room && me.room.leaveChat && typeof me.room.leaveChat === 'function') {
            me.room.leaveChat();
        }
        if (
            me.options &&
            me.options.elements &&
            me.options.elements.inputContainerSelector &&
            me.QTRendererExt
        ) {
            me.QTRendererExt.enableTypingInput();
            setPlaceholder(
                me.context.querySelector(me.options.elements.inputContainerSelector),
                checkSpanishLanguage(me.options)
                    ? ScriptsQuestionTypeToolTips.Spa.Text
                    : ScriptsQuestionTypeToolTips.Eng.Text
            );
        }
        me.stopPredefinedQueue = false; // CHAT-8677 clear global variable when new chat start
        me.hasAnswerInQTChatLogIdToBeUpdated = false; // CHAT-8677 clear global variable when new chat start
        me.options.chatId = 0;
        ApexChat.options.chatEnded = true;
        me.removeSMSToWebNotification();
        me.onChatEnded(cb);
    }

    // ex. endDOMChatSession
    endChatSession() {
        // This is the common code to end dom chat session
        const me = this;
        this.hide();
        me.endChat();
    }

    /*
     * WebSync event handlers
     */
    stopWaiting() {
        window.clearTimeout(ApexChat.waitedTooLongTimeout);
        this.waiting = false;
    }

    resetWaiting() {
        this.stopWaiting();
        this.startWaiting();
    }

    getRequestedTime() {
        const domStartedAt =
            this.options.chatMode == ChatMode.DOM
                ? ApexChat.options._domStartTime
                : fromQueryString('cb') * 1;
        return domStartedAt;
    }

    startWaiting() {
        // if we have a wait timer, and we're not already waiting
        const me = this;
        if (me.options.apologizeForWaitAfter) {
            me.waiting = true;
            // message from the visitor - start watching
            // this should clear any previous timeout as well
            window.clearTimeout(ApexChat.waitedTooLongTimeout);
            ApexChat.waitedTooLongTimeout = window.setTimeout(() => {
                if (!me._ended) {
                    const msg = me.options.apologizeForWaitMessage || "I'm sorry, just one moment.";
                    me.onMessageArrived({
                        id: -1 * new Date().getTime(),
                        // anything greater than 0 works here, we're just telling the visitor anyway
                        userId: TempCache.FAKE_AGENT_ID,
                        createdOn: new Date(),
                        participantDisplayName: me.options.agentName,
                        allowDupe: true,
                        text: msg
                    });
                    const data = {
                        text: msg,
                        participantId: -1,
                        userId: TempCache.FAKE_AGENT_ID,
                        participantDisplayName: me.options.agentName
                    };
                    fm.websync.client.publish({
                        retries: 0,
                        meta: me.getMeta(),
                        channel: `/chatroom/${me.options.chatId}`,
                        data,
                        onSuccess(args) {
                            // nothing
                        }
                    });
                }
            }, me.options.apologizeForWaitAfter * 1000);
        }
    }

    onTypingArrived(args, self) {
        const me = this;

        const indicator = me.typingIndicator;
        if (args && args.indicator) {
            me.showTyping();
            me.stopWaiting();
        } else if (indicator) {
            me.hideTyping();
        }
        // me.postMessage({ event: ChatEvents.OnTypingArrived, data: args.indicator });
        me.state.changeState({
            origin: me.objectType || me.options.objectType,
            toState: ChatEvents.OnTypingArrived,
            value: args.indicator
        });
    }

    onChatEnded(cb) {
        const me = this;
        // me.introContainer.html('The chat session has ended.');
        // me.introContainer.show();
        me.participantsContainer?.style.display = 'none';
        // chat ends, always clear the timer
        window.clearInterval(this._countDownInterval);
        this._ended = true;
        const cookieHandler = new ChatCookieHandler();
        cookieHandler.DeleteCookie();
        me.$(me.options.elements.transferChatSelector, me.context).hide();
        me.$(me.options.elements.actionMenuStartSMSChat, me.context).hide();
        me.$(me.options.elements.actionMenuLanguageSwitcher, me.context).hide();
        // me.state.changeState({ toState: ChatStates.Ended, value: true });
        // stop typing indicator when chat ended.
        me.onTypingArrived({ indicator: false });
        if (cb && typeof cb === 'function') {
            cb();
        }
    }

    onCallStatusArrived(args) {
        const indicator = me.$(this.options.callIndicatorSelector);
        if (args.status == 1 || args.status == 2 || args.status == 3) {
            indicator.show();
        } else {
            indicator.hide();
        }
        /* window.setTimeout(function () {
        // after 10 seconds, hide the indicator if it's still visible
        indicator.hide();
        }, 10000); */
    }

    onParticipantsChanged(participants) {
        const me = this;
        const config = ParticipantsChanged(participants, {
            $: me.$,
            options: this.options,
            hideWaitingIndicator: this.hideWaitingIndicator,
            participantsHasBeenGreaterThanOne: this._participantsHasBeenGreaterThanOne,
            ended: this._ended,
            isExitPopup: this.mode == WidgetTypes.ExitPopup,
            userTitleSelector: this.$(this.options.elements.agentTitle, this.context),
            imageObjSelector:
                this.mode == WidgetTypes.ExitPopup
                    ? this.$('.Apex-agentImage', this.context)
                    : this.$(this.handlerImageSelector),
            participantsContainer: this.participantsContainer
        });
        this.options = config.options;
        this.participantsContainer = config.participantsContainer;
    }

    afterSMSChatTransfer() {
        const me = this;
        disableTypingInput.bind2(me)(me,
            me.options.elements.inputContainerSelector,
            '...'
        );
        me.hideTyping(); // CHAT-7884 hide typing indicator when chat has been transferred successfully
        // idel out current chat room
        me.postMessage({
            event: WidgetTypes.ChatRoom + ChatEvents.ChatIdleOut
        });
    }

    /**
     * renders SMS Chat Transfer UI and ends current DOM chat
     * @param {any} m: system message
     */
    renderUIOnChatTransfer(m) {
        const me = this;

        const notifications = {
            transferStatus: 'Chat is being transferred to SMS...',
            transferStatusUpdate:
                'Your chat has been transferred; please check your phone for the text from our specialist.'
        };
        if (m && m.systemMessageType == SystemMessageType.SMSTransferInProgress) {
            // notifications.transferStatus = m.text;//uncomment when server message is to be shown
        } else if (m && m.systemMessageType == SystemMessageType.SMSTransferred) {
            // notifications.transferStatusUpdate = m.text;//uncomment when server message is to be shown
        } else {
            return; // on invalid status, bail out
        }

        const transferChatUI = new SimpleView({
            context: me.context,
            identifier: `apexchat_transferChat_ui_${m.id}`,
            template: me.options.smsTransferChatUI,
            model: notifications,
            classes: [
                'apexchat_auto_genned_message_wrapper',
                'agent_message',
                'apexchat_message_left'
            ],
            wrap: true,
            targetElementSelector: me.options.elements.messagesContainerSelector,
            afterRender() {
                const transferringContainer = this.getContainer().children[0];
                const transferredContainer = this.getContainer().children[1];
                const elStatusToShow =
                    m.systemMessageType == SystemMessageType.SMSTransferInProgress
                        ? transferringContainer
                        : transferredContainer;
                const elStatusToHide =
                    m.systemMessageType == SystemMessageType.SMSTransferInProgress
                        ? transferredContainer
                        : transferringContainer;
                // play show/hide when transferring:
                // hide transfer complete UI and show transfer in progress UI
                showElement(elStatusToShow);
                hideElement(elStatusToHide);
                me.afterSMSChatTransfer();
                // and show transfer complete UI
                setTimeout(() => {
                    showElement(elStatusToHide);
                    hideElement(elStatusToShow);
                }, TempCache.SMS_TRANSFER_CHAT_DELAY * 1000);
            }
        });
        me.autoScroll();
    }

    showTyping(args) {
        const me = this;
        // logIt('typing arrived:' + args);
        me.typingIndicator.html(`${me.options.model.agentName} is typing...`);
        me.typingIndicator.show();
    }

    hideTyping(args) {
        const me = this;
        if (me.mode == WidgetTypes.ExitPopup) {
            me.typingIndicator.html('');
        } else {
            me.typingIndicator.hide();
        }
    }

    predefinedMsgsOnRefresh(m, msg, index) {
        const me = this;
        m.text = msg;
        m.participantDisplayName = me.options.model.agentName;
        me.preserveChatArray.push({ index, predefinedMsgs: msg });
        me.onMessageArrived(m);
    }

    predefinedMsgs(m, msgDuration, msg, index) {
        const me = this;
        if (me.totalDuration === undefined) {
            me.totalDuration = msgDuration;
        } else {
            me.totalDuration += msgDuration;
        }
        setTimeout(() => {
            if (!me.isUserTyping) {
                me.showTyping();
            } else {
                me.hideTyping();
            }
        }, msgDuration * 700);
        setTimeout(() => {
            me.hideTyping();
            if (!me.isUserTyping) {
                if (Cookies.get(WidgetTypes.ExitPopup) != WidgetStates.Closed) {
                    // CHAT-9756 Visitors won't hear the EP messages sound after closing the widget.
                    const soundName =
                        Cookies.get(VISITOR_MESSAGE_SOUND.name) ||
                        VISITOR_MESSAGE_SOUND.tune;
                    me.playSoundEPPredefinedMessage(soundName); // JIRA_2491 - EP Predefined messages comes with sound.
                }
                msg = removeTextFollowedByColon(msg);

                m.text = msg;
                m.participantDisplayName = me.options.model.agentName;
                me.preserveChatArray.push({
                    index,
                    predefinedMsgs: msg,
                    answerScript: m.answerScript,
                    agentParticipantId: ParticipantIds.predefined,
                    userId: UserIds.simulated,
                    participantDisplayName: me.options.agentName || me.options.model.agentName,
                    delayTime: msgDuration
                });
                m.text = removeTextFollowedByColon(m.text);
                const messageInterval = me.options.model.questionTypeDelay * 1000; // set default interval
                const PipedMessageHandlerSingleton = new PipedMessageHandler();
                if (
                    PipedMessageHandlerSingleton.isValidPipedMessage({
                        m
                    })
                ) {
                    logIt(`RDEP::processing piped${m.text}`);
                    PipedMessageHandlerSingleton.startPolling({
                        init() {
                            me.postMessage({
                                event: ChatEvents.OnTypingArrived,
                                value: { indicator: true }
                            });
                        },
                        async startPollingCallback(m) {
                            logIt(`RDEP::startPollingCallback:${m.text}`);

                            me.postMessage({
                                event: ChatEvents.OnMessageArrived,
                                value: {
                                    m,
                                    initialLoad: false,
                                    index
                                }
                            });
                            me.postMessage({
                                event: ChatEvents.OnTypingArrived,
                                value: { indicator: true }
                            });
                        },
                        lastPollingCallback(args) {
                            logIt(`RDEP::lastPollingCallback:${args.m.text}`);
                            me.postMessage({
                                event: ChatEvents.OnTypingArrived,
                                value: { indicator: false }
                            });
                            me.postMessage({
                                event: ChatEvents.OnMessageArrived,
                                value: {
                                    m: args.m,
                                    initialLoad: false,
                                    index
                                }
                            });
                        },
                        messageDisplayDuration: messageInterval
                    });
                } else {
                    me.onMessageArrived(m);
                }
                if (m.isLastPredefinedMessage) {
                    // when last predefined message shown start poke message job.
                    me.postMessage({
                        event: ChatEvents.OnPredefinedCompleted
                    });
                }
            }
        }, msgDuration * 1000);
    }

    renderMultiLanguageDropDown(config) {
        var me = this;
        if (!me.switchLang) {
            me.switchLang = new SwitchLanguage(me);
        }
        me.switchLang.implementMultiLanguageSupport = me.implementMultiLanguageSupport.bind(me);
        me.switchLang.renderMultiLanguageDropDown(config);
    }

    async enableChatTransfer(chatId) {
        const me = this;
        const module = await import(/* webpackChunkName: "chatTransfer" */ './ChatTransfer')
        const ChatTransfer = module.default;
        me.chatTransfer = new ChatTransfer({
            webSyncClient: me.room.webSyncClient,
            chatId,
            onTransferRequested(arg) {
                me.requestAgentForTransferChat();
            },
            onTransferSuccess(args) {
                if (!args.data) {
                    me.postMessage({
                        event: ChatEvents.onOperatorNotAvailable,
                        data: { message: 'operator is not available' }
                    });
                }
            }
        });
        return me.chatTransfer;
    }

    queuePredefinedQTs(m) {
        const me = this;
        me.isPredefinedMsgsRendered = true;
        m = Object.assign(m, {
            agentParticipantId: ParticipantIds.predefined, // CHAT-6370 predefined participantId -4
            userId: UserIds.simulated,
            isSimulatePredefinedMessage: true
        });
        const predefinedMsgArray = ApexChat.options.exitpopup.exitPopupMessages;
        const _queueMessage = function () {
            if (me.stopPredefinedQueue) {
                return;
            }
            const nextPredefinedMessage = predefinedMessagesQueue.dequeue();
            if (nextPredefinedMessage) {
                // CHAT-8530 Uncaught TypeError in the console - check for undefined value
                const predefinedMessage = Object.assign(nextPredefinedMessage, {
                    agentParticipantId: ParticipantIds.predefined, // CHAT-6370 predefined participantId -4
                    isSimulatePredefinedMessage: true,
                    participantDisplayName: me.options.model.agentName,
                    id: nextPredefinedMessage.id, // CHAT-8519 Timestamp doesn't appear after 1st Plain Text pre-defined response on RD EP.
                    userId: TempCache.EP_PREDEFINED_AGENT_ID,
                    createdOn: new Date(),
                    isPredefinedMsg: true,
                    isPageRefreshed: me.isPageRefreshed()
                });
                // CHAT-7942 : If predefined message is QT & NOT None-Type then it should considered as QT, render QT-None as Plain-Text.
                me.accumulatedTime = me.accumulatedTime || 0;
                me.accumulatedTime =
                    getCookieValue('apexchat_exitpopup_predefined_messages_rendered') ===
                        'true' && m.isPageRefreshed
                        ? 0
                        : predefinedMessage.duration;
                predefinedMessage.duration = me.accumulatedTime;
                if (predefinedMessage.isLastPredefinedMessage) {
                    // exit popup last message render then insert true in cookie
                    Cookies.set('apexchat_exitpopup_predefined_messages_rendered', true);
                }
                if (
                    predefinedMessage.messageType === QTGridMessageType.agent_Script &&
                    predefinedMessage.questionType != ScriptsQuestionType.None
                ) {
                    me.stopPredefinedQueue = true;
                    me.renderPredefinedQTs(predefinedMessage);
                } else {
                    me.renderPredefinedQTs(predefinedMessage);
                }
            }
        };
        var predefinedMessagesQueue = new Queue();
        for (let i = 0; i < predefinedMsgArray.length; i++) {
            predefinedMsgArray[i].isPredefinedMessage = true;
            if (i == predefinedMsgArray.length - 1) {
                predefinedMsgArray[i].isLastPredefinedMessage = true;
            }
            predefinedMessagesQueue.enqueue(predefinedMsgArray[i]);
        }
        _queueMessage();
        me.subscribe('predefined-message-completed', () => {
            _queueMessage();
        });
    }

    renderPredefinedQTs(m) {
        let message = m;
        const me = this;
        if (message.messageType === QTGridMessageType.agent_Script) {
            message = Object.assign(m, {
                scriptAnswerId: m.agentScriptAnswerId,
                options: m.agentScript?.agentScriptOptions,
                questionType: m.agentScript?.questionType || m.questionType,
                messagePlaceholder: m.agentScript?.messagePlaceholder,
                visitorResponseType: m.agentScript?.visitorResponseType,
                visitorResponseTypes: m.agentScript?.visitorResponseTypes,
                answerScript: m.agentScript || m.answerScript
            });
            message.answerScript = Object.assign(m.answerScript, {
                agentScriptAnswerId: m.scriptAnswerId
            });
        }
        me.predefinedMsgs(m, m.duration || 1, m.message, m.order);
    }

    renderPredefinedMessages(m) {
        const me = this;
        me.isPredefinedMsgsRendered = true;
        const countingArray = ['Primary', 'Secondary', 'Third', 'Fourth', 'Fifth'];
        let msgDuration = 0;
        for (let i = 0; i < countingArray.length; i++) {
            const msgVar = `popup${countingArray[i]}Message`;
            const msgNo = `popup${countingArray[i]}Duration`;
            let msg = me.options.model.exitpopup[msgVar];
            msgDuration += me.options.model.exitpopup[msgNo];
            if (msg) {
                // FogBugs [2283] - Typing Indicator issue was resolved by adding
                msg = parseTemplate(msg, me.options.model);
                if (!m.isPageRefreshed) {
                    me.predefinedMsgs(m, msgDuration, msg, i);
                } else {
                    // Render predefined messages in page refresh case
                    me.predefinedMsgsOnRefresh(m, msg, i);
                }
            }
        }
    }

    checkArrayDuplication(array, msg, property) {
        let i = array.length;
        while (i--) {
            if (array[i][property] === msg || array[i][property] === decodeHTML(msg)) {
                return true;
            }
        }
        return false;
    }

    publishPredefinedMessages(callback) {
        const me = this;
        let lastPredefinedMsg = null;
        // Introduced "Batch" for sending multiple published messages in a sequence.
        // source: https://docs.frozenmountain.com/websync4/#class=websync-code-snippets-batching-data
        me.room.startBatch();
        logIt(`EP::CHAT:: ABOUT TO publish...${JSON.stringify(me.preserveChatArray)}`);
        me.isPreDefinedMessagesSent = true;
        for (var i = 0, j = 0; i < me.preserveChatArray.length; i++) {
            if (me.preserveChatArray[i].delayTime !== undefined && i > 0) {
                me.totalDuration -= me.preserveChatArray[i].delayTime;
            }
            var message = {
                isForAIBot: ApexChat.options.aiBotEnabled,
                chatMsg: me.preserveChatArray[i].predefinedMsgs || me.preserveChatArray[i].text,
                agentParticipantId: me.preserveChatArray[i].agentParticipantId, // CHAT-6370 predefined participantId -4
                userId: me.preserveChatArray[i].userId || UserIds.visitor,
                answerScript: me.preserveChatArray[i].answerScript,

                isPredefinedResponse: me.preserveChatArray[i].isPredefinedResponse,
                createdOn: me.preserveChatArray[i].createdOn,
                participantId: me.preserveChatArray[i].participantId,
                participantDisplayName: me.preserveChatArray[i].participantDisplayName,
                delayTime: me.totalDuration,
                onSuccess(args) {
                    ++j;
                    if (args && args.userId != ParticipantIds.pokeMessage) {
                        lastPredefinedMsg = args;
                    }
                    if (j == me.preserveChatArray.length) {
                        // run callback only after last predefined msg has been published
                        args =
                            me.preserveChatArray[me.preserveChatArray.length - 1].userId ===
                                ParticipantIds.pokeMessage
                                ? lastPredefinedMsg
                                : args;
                        // If last message is poke message then we need to send the last predefined message instead of poke message
                        me.preserveChatArray = []; // clear
                        if (callback && typeof callback === 'function') {
                            callback.bind2(me)(args);
                        }
                    }
                },
                onFailure(args) {
                }
            }
            me.room.sendMessage(message);
        }
        me.room.endBatch();
    }

    async onMessageArrived(m, initialLoad, index, lastSplitMsgCallback, fromHere) {
        const me = this;
        if (me.fileUploader && m.visitorAttachedFiles && m.visitorAttachedFiles.length > 0) {
            me.fileUploader.showFilesInMessage(m.id, m.visitorAttachedFiles)
        }
        if (m.questionType >= 0 &&
            m.questionType != ScriptsQuestionType.FullText &&
            m.questionType != ScriptsQuestionType.None &&
            m.questionType != ScriptsQuestionType.VideoGreet
        ) {
            me.$(".apexchat_rd_input_wrapper", me.context).addClass("livechat_is_current_qt_msg");
        } else { // if (!m.questionType && m.participantId > 0) this comment to be removed
            me.$(".apexchat_rd_input_wrapper", me.context).removeClass("livechat_is_current_qt_msg");
        }
        if (m.errorMessage) {// this is only active in conversational bot case only
            console.log(m.errorMessage);
        }
        if (m.scriptAnswerId) {
            Cookies.set('lastMessageAnswerId', m.scriptAnswerId);
        }
        if (m.isAIBotReply) {
            ApexChat.AIResponseReceived = true;
        }
        const isSystemMessage = m.systemMessageType == SystemMessageType.SMSOptIn || m.questionType == ScriptsQuestionType.WebToSMSNotification;
        m.text = ApexChat.options
            ? parseTemplate(
                removeTextFollowedByColon(decodeHTML(m.text)),
                ApexChat.options
            )
            : parseTemplate(
                removeTextFollowedByColon(decodeHTML(m.text)),
                me.options
            );
        if (
            m.participantId == ParticipantIds.pokeMessage &&
            me.isChatActive()
        ) {
            /* HANDLE POKE MESSAGE FOR RD THEME ONLY */
            me.postMessage({
                event: WidgetTypes.PokeMessagesOverLay + ChatEvents.OnPokeMessageArrived,
                data: { m }
            });
            // We need to notify MessageQueue that message is handled and proceed further for next message
            me.notifyMessageHandled(m);
            return false;
        }
        if (m.participantId === -1) {
            me.$('.live_chat_scheduler_bg', me.context).each(function (index) {
                me.$(this).disable({ applyGrayBackground: true });
            });
        }
        me.isChatTransferredToOperator(m);
        // if CHAT transfer from script bot to livechat we need to enable text field CHAT-7919
        if (
            !me.isTransferredToLiveAgent() &&
            m.userId === ParticipantIds.system &&
            m.systemMessageType === SystemMessageType.TransferToLiveAgent
        ) {
            me.setTransferredToLiveAgent();
        }
        // Donot continue further if the text is empty and chat message is from visrtual assistant (Lumin)
        if (!m.text && m.virtualAssistantStatus > 0) {
            return;
        }
        /* checking if message text contain invalid html then correct and replace message with correct one */
        m.text = cleanInvalidHtml(m.text);
        // if userId is null then something went wrong
        // if userId is -6 (non visitor system message), it means this message is not supposed to show to visitor
        if (
            m.userId == null ||
            m.userId == ParticipantIds.nonVisitorSystem ||
            me.isOperatorAvailable(m)
        ) {
            // We need to notify MessageQueue that message is handled and proceed further for next message
            me.notifyMessageHandled(m);
            return;
        }
        if (m.shouldShowChatEndedMessage) {
            m.text = GlobalVariables.CHAT_ENDED_MESSAGE;
        }
        // [EP] - Predefined msgs - START
        if (
            !m.isPredefinedMsg &&
            me.checkArrayDuplication(me.preserveChatArray, m.text, 'predefinedMsgs') &&
            me.mode == WidgetTypes.ExitPopup
        ) {
            // We need to notify MessageQueue that message is handled and proceed further for next message
            me.notifyMessageHandled(m);
            return;
        }
        // If message is predefined response we need to return it because we have already shown it.
        if (m.isPredefinedResponse) {
            me.postMessage({
                event: ChatEvents.OnTypingArrived,
                value: { indicator: false }
            });
            return;
        }
        // CHAT-7226  Next Mapped Question Logic Change
        // as option property removed from backend now we explicity add option property to our msg.options object,
        // because all QT UI depend upon that property.
        if (m.questionType != ScriptsQuestionType.None && m.options) {
            m.options = addOptionProperty(m.options);
        }
        // JIRA_4190 - PreChat msgs got repeated if chat is minimized
        // summary: we are not rendering the String text Answer of QuestionType because we have some UI to show Tick of user selected options.
        // So, we have three conditions to be TRUE for not to render QuesntionType Answer,
        // 1- Dont Render IF the message is QuestionType reply from USER
        // 2- initialLoad should be false, this flag indicate that the chat is from History used in refresh scenarios, In this case we need the string text of QuestionType Answer from USER to be rendered.(JIRA_4190 for more explanation)
        // 3- The DOM should not be minimized because If DOM would be minimized means PreChat would be appeared and If Agent sends a QuestionType msg and User answers it than we want it to be rendered.(JIRA_4190 for more explanation)
        if (/*! initialLoad && */ m.options == 'QuestionTypeAnswer') {
            // We need to notify MessageQueue that message is handled and proceed further for next message
            me.notifyMessageHandled(m);
            return;
        }
        // show chat popout icon in case of chat mode is windowed
        if (
            m.chatId &&
            m.chatId > 0 &&
            me.options.elements.popoutSelector &&
            me.options.chatMode != ChatMode.DOM
        ) {
            me.$(me.options.elements.popoutSelector, me.context).show();
        }
        // questionTypeResponseChatLogId is ChatLog of the Last Answer of QT which is to be replaced with New Answer
        // therefore, it has to be removed from UI before appending new Answer
        const tracker = new TimeTracker()
        tracker.check('v3/messageArrived/Greeting');
        if (m.questionTypeResponseChatLogId && m.questionTypeResponseChatLogId > 0) {
            const lastLogMessage = me.$(
                `#apexchat_chatlog_${m.questionTypeResponseChatLogId}`,
                me.context
            );
            logIt(`>>>${lastLogMessage}`);
            if (lastLogMessage) {
                me.$(lastLogMessage).parent().remove();
            }
        }

        // CHAT-5829-Quick Reply Message unclickable
        // save last msg id to compare with last questiontypeid available to make last message clickable
        let lastMsgId = ApexChat.storageAPI.Get('lastMsgId');
        if (m.isChatEnded) {
            // disable all previous QT's if chat ended
            var questionTypeId = ApexChat.storageAPI.Get('questionTypeId');
            var isLastMsgWasQType = parseInt(lastMsgId) === parseInt(questionTypeId);
            if (isLastMsgWasQType) {
                me.QTRendererExt &&
                    me.QTRendererExt.questionTypeRenderer &&
                    me.QTRendererExt.questionTypeRenderer.afterSubmit();
            }
        }
        /** CHAT-6049-QR-Greeting Message
         * to see if its a first message and no lastmsgId available inside cookies,
         * because when we refresh page method rerun all messages , so lastMsgId is already filled that means that msg already appeared */
        const isGreetingMessageQuestionType = me.isGreetingQuestionType(m, index); // check is greeting message is a question type

        logIt(`isGreetingMessageQuestionType:${isGreetingMessageQuestionType}`);
        /*
                 * first conditon is that if new message arrived its index is undefined and userId equals to 0 or greater then 0 so we consider it a new message and put in our lastmsgid when
                 * pages refreshed every message comes with its index which means that its just loading messages so lastmsgid will not get updated when page refresh,
                 * for second conditon isGreetingMessageQuestionType just check first greeting message is question type then add it on lastmsgid, so its accessible after refresh
                 third and fourth conditions are to update lastMsgId if the chat is transferred because previously it's making QR clickable (in later condition at line no. 2938) even after chat transfer via menu or dashboard CHAT-9753 */
        if (
            (!initialLoad && !index && m.userId >= 0) ||
            isGreetingMessageQuestionType ||
            SystemMessageType.TransferToLiveAgent == m.systemMessageType ||
            SystemMessageType.Default == m.systemMessageType
        ) {
            // add to lastmsgid if new message arrived or greeting message is question type
            lastMsgId = m.id || 0;
            ApexChat.storageAPI.Store('lastMsgId', lastMsgId);
        }
        var questionTypeId = ApexChat.storageAPI.Get('questionTypeId');
        var isLastMsgWasQType = parseInt(lastMsgId) === parseInt(questionTypeId); // compare if our last message is question type then after refresh it should be clickable
        if (
            !m.questionTypeResponseChatLogId &&
            !m.isFromPreChat &&
            questionTypeId &&
            m.id != -1 &&
            !isLastMsgWasQType &&
            !(m.participantId === ParticipantIds.bot)
        ) {
            //  m.participantId !== -2 /*stop executing for System messages coming in refresh scenario: _All visitors have left the chat_*/
            if (me.QTRendererExt && me.QTRendererExt.questionTypeRenderer && !isSystemMessage) {
                me.QTRendererExt.questionTypeRenderer.afterSubmit();
                ApexChat.storageAPI.Remove('questionTypeId', questionTypeId);
            }
        }
        // [EP] - Predefined msgs - END
        // m.text = ApexChat.convertCodeToEmoji(m.text);
        m.text = new EmojiUtils().parse(m.text); // ref. CHAT-3836
        // me.onTypingArrived({ indicator: false });
        const initialArgs = arguments;
        me.exitMessage = false;
        // if a message is coming in due to the auto greet flag or due to agent pick up of chat, but this is not the first message from an agent, then skip it
        if (
            m.userId == TempCache.AUTOGREET_AGENT_ID ||
            (m.isGreeting && !TempCache.IS_GREETING_QUESTIONTYPE && !m.isSplitMessage)
        ) {
            me.$('.apexchat_message .apexchat_text', me.messagesContainer, me.context).each(
                function () {
                    if (
                        me.$(this, me.context).parent().hasClass('apexchat_agent') ||
                        (me.$(this, me.context).parent().parent() &&
                            me.$(this, me.context).parent().parent().hasClass('apexchat_agent'))
                    ) {
                        {
                            me.exitMessage = true;
                            // exit from each
                        }
                    }
                }
            );
        }
        if (me.exitMessage) {
            // We need to notify MessageQueue that message is handled and proceed further for next message
            me.notifyMessageHandled(m);
            return;
        }
        const handleMessage = async (m) => {
            m.id = m.id || 0;
            m.createdOn = m.createdOn || null;
            if (me.options.model.aiBotEnabled && !me.options.model.botGuid && m.questionType === ScriptsQuestionType.FullText) {
                m.questionType = ScriptsQuestionType.Text
                m.visitorResponseTypes = `[${m.visitorResponseType}]`
            }
            // avoid duplicate messages
            if (me.$(me.options.elements.chatLogSelectorPrefix + m.id, me.context).length) {
                // We need to notify MessageQueue that message is handled and proceed further for next message
                me.notifyMessageHandled(m);
                return;
            }
            if (m.participantDisplayName == 'Visitor' || !m.participantDisplayName) {
                me.options.participantDisplayName = m.participantDisplayName;
                m.participantDisplayName = 'You';
                if (!ApexChat.IsShowDisclaimeOverlay && me.options.shouldShowLocationDisclaimer) {
                    ApexChat.IsShowDisclaimeOverlay = true;
                    me.showDisclaimerOverlay(me.options.locationDisclaimerText);
                }
            } else if (
                m.participantDisplayName != 'You' &&
                !m.isChatEnded &&
                !me.isPageRefreshed() &&
                m.participantId != ParticipantIds.system
            ) {
                // added a check for system message i-e -1, so agentname is not displayed instead of 'system' in v3.
                // In chat refresh case if multiple user participant work on chat. The actual participant name should display
                m.participantDisplayName = me.options.agentName || me.options.model.agentName;
            }
            // If found predefined or prechat message it means the first message has arrived.
            // CHAT-7321 if message is split message set firtMessageArrived so later irrelevant setTimeout will not apply as we used for first message
            if (
                (m.userId == UserIds.simulated &&
                    m.participantId == ParticipantIds.predefined) ||
                m.participantId == ParticipantIds.prechat ||
                m.isSplitMessage ||
                m.questionType === ScriptsQuestionType.VideoGreet
            ) {
                me.firstMessageArrived = true;
            }
            // test to exclude visitorinfo form text
            const visitorInfoTest = /^\(via Submit Form [a-zA-Z]+\)/gi;
            if (typeof String.prototype.trim !== 'function') {
                String.prototype.trim = function () {
                    return this.replace(/^\s+|\s+$/g, '');
                };
            }
            if (visitorInfoTest.test(m.text)) {
                if (/^\(via Submit Form Message\)/gi.test(m.text)) {
                    m.text = m.text.substring(m.text.indexOf(')') + 1).trim();
                } else {
                    return false;
                }
            }
            if (me.clickButton && me.$(me.clickButton).isDisabled()) {
                me.$(me.clickButton).enable({ applyGrayBackground: false });
            }
            let officeMessageTemplate = null; // we will set this only when the agent's message is office hours
            if (m.userId != 0) {
                // not visitor's msg
                // detect company hours and convert raw text into well-formatted html
                const officeHrsValidationResult = isMessageCompanyHours(m.text); // validate 1st
                if (officeHrsValidationResult.result) {
                    if (me.mode == WidgetTypes.ExitPopup) {
                        officeMessageTemplate =
                            epOfficeHoursMessageTemplate;
                    } else {
                        officeMessageTemplate = domOfficeHoursMessageTemplate; /* for DOM */
                    }
                    // make the parsed message template as message's html not text
                    m.html = parseCompanyHours(
                        m.text,
                        officeHrsValidationResult,
                        true
                    );
                }
            }
            let content;
            if (me.mode == WidgetTypes.ExitPopup) {
                m.cssClass =
                    m.participantDisplayName == 'You'
                        ? 'user'
                        : m.participantDisplayName == 'System'
                            ? 'system'
                            : 'bot';
                if (!m.html) {
                    if (!m.handlerImageUrl) {
                        m.handlerImageUrl = me.options.model?.handlerImageUrl;
                    }
                    content = ImportEPTemplateFactory().exitPopupMessageTemplate(m);
                } else {
                    content = officeMessageTemplate(m);
                }

            } else {
                if (!m.html) {
                    m.handlerImageUrl = AgentImageHandler(me.options.handlerImageUrl);
                    content = createMessageTemplateFactory(m).domMessageTemplate;
                } else {
                    content = officeMessageTemplate(m);
                }
            }
            logIt(`CH::content\n${content}`);
            // [Exitpopup]: It is to set CSS Class for Exit Popup predefined messages.
            if (
                m.participantId == ParticipantIds.bot &&
                m.participantDisplayName == me.options.model.agentName
            ) {
                content = content.replace('apexchat_visitor', 'apexchat_agent');
                content = content.replace('apexchat_rd_sent', 'apexchat_rd_received');
                content = content.replace('apexchat_rd_float_right', 'apexchat_rd_float_left');
            }
            let dupe = false;
            // remove any html tags before comparison
            const html = m.text;
            var div = document.createElement('div');
            div.innerHTML = html;
            let text = div.textContent || div.innerText;
            // replace any non numeric or non alphabetic characters
            text = text.replace(TempCache.REMOVE_NON_ALPHANUMERIC, '');
            // index will tell us the index of the message if it already exists
            // only allow duplicate messages from agents if they are consecutive as an agent may ask severl times: Is there anything else I can helo you with....
            if (Browser.isIE8()) {
                var index = arrayObjectIndexOf(
                    me.$('.apexchat_message .apexchat_text', me.messagesContainer, me.context),
                    text,
                    'innerText'
                );
            } else {
                var index = arrayObjectIndexOf(
                    me.$('.apexchat_message .apexchat_text', me.messagesContainer, me.context),
                    text,
                    'textContent'
                );
            }
            me.$('.apexchat_message .apexchat_text', me.messagesContainer, me.context).each(
                function () {
                    // greeting should not be repeated no matter what
                    if (index == 0) {
                        if (
                            me
                                .$(this, me.context)
                                .text()
                                .replace(TempCache.REMOVE_NON_ALPHANUMERIC, '') == text
                        ) {
                            if (
                                me.$(this, me.context).parent().hasClass('apexchat_agent') &&
                                m.userId != 0
                            ) {
                                dupe = true;
                            } else if (
                                me.$(this, me.context).parent().parent() &&
                                me
                                    .$(this, me.context)
                                    .parent()
                                    .parent()
                                    .hasClass('apexchat_agent') &&
                                m.userId != 0
                            ) {
                                dupe = true;
                            }
                        }
                    }
                    if (index > 0) {
                        // do not allow duplicates only in they occur consecutively
                        if (
                            me.$(this).text().replace(TempCache.REMOVE_NON_ALPHANUMERIC, '') ==
                            text &&
                            index ==
                            me.$(
                                '.apexchat_message .apexchat_text',
                                me.messagesContainer,
                                me.context
                            ).length -
                            1
                        ) {
                            if (
                                me.$(this, me.context).parent().hasClass('apexchat_agent') &&
                                m.userId != 0
                            ) {
                                dupe = true;
                            } else if (
                                me.$(this, me.context).parent().parent() &&
                                me
                                    .$(this, me.context)
                                    .parent()
                                    .parent()
                                    .hasClass('apexchat_agent') &&
                                m.userId != 0
                            ) {
                                dupe = true;
                            }
                        }
                    }
                }
            );
            if (!me.options.model.aiBotEnabled && dupe && !m.allowDupe /* && m.userId != FAKE_AGENT_ID */) {
                // We need to notify MessageQueue that message is handled and proceed further for next message
                me.getNotifyMessageHandler.call(me, m);
                return;
            }
            if (m.userId == -2) {
                // We need to notify MessageQueue that message is handled and proceed further for next message
                me.notifyMessageHandled(m);
                // "bot" messages, ignored by visitor
                return;
            }
            // the message came from an agent
            if (
                m.userId != 0 &&
                !getCookieValue(TempCache.APEXCHAT_PRECHAT_MESSAGE_SENT_COOKIE)
            ) {
                // if this is the first message from an agent, we have a special condition;
                // the first message is auto-sent, but we don't want it to *appear* auto-sent
                // so, we'll hold this message momentarily, showing the typing indicator
                if (!me.firstMessageArrived && me.options.isNewChat) {
                    logIt('DELAY::INITIAL_DELAY_AGENT_PICKUP::OUT');
                    me.firstMessageArrived = true;
                    if (me.options.model.agentName) {
                        me.onTypingArrived({
                            indicator: true,
                            participantDisplayName: me.options.model.agentName
                        });
                    } else {
                        me.onTypingArrived({
                            indicator: true,
                            participantDisplayName: m.participantDisplayName
                        });
                    }

                    window.setTimeout(() => {
                        logIt('DELAY::INITIAL_DELAY_AGENT_PICKUP::IN');

                        me.onTypingArrived({ indicator: false });
                        me.onMessageArrived.apply(me, initialArgs);
                    }, me.INITIAL_DELAY_AGENT_PICKUP);
                    // TODO: test
                    me.state.changeState({
                        origin: me.objectType,
                        toState: ChatStates.GreetingShown
                    });
                    return;
                }
                window.clearInterval(me._countDownInterval);
            }
            // for operator chats, me.options.agentName will be blank,so hideWaitingIndicator will not be called
            // waiting Indicator will be hidden through  'onParticipantsChanged'
            if (me.options.model.agentName) {
                me.hideWaitingIndicator(`Visitor, ${me.options.model.agentName}`);
            }
            // create the actual message contents and display
            var div = document.createElement('div');
            // div.id = this.options.chatLogSelectorPrefix + m.id;
            let msgType = '';
            let isVisitorResponse = false;
            if (m.userId === ParticipantIds.system) {
                msgType = 'system_message apexchat_message_left';
            } else if (m.userId === ParticipantIds.visitor) {
                msgType = 'vistor_message apexchat_message_right';
                isVisitorResponse = true;
            } else if (m.userId > 0 || m.userId === ParticipantIds.prechat) {
                msgType = 'agent_message apexchat_message_left';
            }
            ApexChat.VisitorResponse = isVisitorResponse;
            div.className = `apexchat_auto_genned_message_wrapper ${msgType}`;
            div.id = `apexchat_message_container_${msgType}`;
            div.setAttribute('chatlogid', m.id);
            me.chatLogArray = me.chatLogArray || [];
            me.chatLogArray.push({
                id: m.id,
                isVisitorResponse
            });
            div.tabIndex = 0;
            // Ref. CHAT-6860: We always need a handler now; not just for QT - hence removed the if-block
            // if (!me.questionTypeRenderer && m.questionType != ScriptsQuestionType.None) {
            await me.injectQuestionTypeRenderer(); // when message is question type, we need to inject questiontype Renderer
            // possible error scenario except for RD/EP predefined msgs
            // }
            logIt(`visitorResponseType:${m.visitorResponseType}`);
            if (!isSystemMessage && m.userId != 0) {
                var cb =
                    m.questionType !== ScriptsQuestionType.FullText
                        ? me.handleQuestionType.bind2(me)
                        : me.handleFullTextType.bind2(me, m);
                //set respnse callback as before; but different way
                me.QTRendererExt.questionTypeRenderer.options.responseCallback = cb;
            }
            me.QTRendererExt.questionTypeRenderer.options.createChatRoom =
                me.createChatRoom.bind2(me);
            me.QTRendererExt.questionTypeRenderer.options.isChatroomAlive = me.isChatroomAlive.bind2(me);
            me.QTRendererExt.questionTypeRenderer.options.loadChatRoom = me.loadChatRoom.bind2(me);
            me.QTRendererExt.questionTypeRenderer.options.enableChatTransferCallback =
                me.enableChatTransfer.bind(me);
            me.QTRendererExt.questionTypeRenderer.options.showOperatorNotAvailableOverlayCb =
                me.showOperatorNotFoundOverlay.bind(me);
            me.QTRendererExt.questionTypeRenderer.options.afterFlatPickerLoaded = function () {
                me.autoScroll();
            };
            logIt(
                `isGreetingMessageQuestionType:${isGreetingMessageQuestionType}:${m.text}`
            );
            const _playSound = function (conditions) {
                if (conditions) {
                    // after the first load, flash the title and play a sound
                    return me.notifyNewMessageArrived.bind2(
                        me,
                        m.isSplitMessage || m.questionType > 0
                    ); // JIRA_2905 - Play sound only for agent message. (Its cookie based for visitor-end incoming sound) and notifyMessage was using Dashboard sound cookie)
                }
            };
            const soundOnLastPipeMessage = m.isSplitMessage && m.isLastSplitMessage; // CHAT-8290- Play sound only on last message of pipe.
            m.beepAfterRender = _playSound(
                (!m.isSplitMessage || soundOnLastPipeMessage) &&
                ((!initialLoad && m.userId != 0) ||
                    (initialLoad && m.userId == TempCache.SIMULATED_AGENT_ID))
            );

            m.isDocument = m.isDocument || (m.agentScript && m.agentScript.isDocument);
            m.agentScriptDocuments = m.agentScriptDocuments || (m.agentScript && m.agentScript.agentScriptDocuments);
            const mqtMeta = {
                meta: {
                    instruction: m.messagePlaceholder
                        ? m.messagePlaceholder
                        : me.QTRendererExt.inputTitle,
                    isFullText: false
                },
                msg: m
            };
            if (
                ((m.isAIBotReply || m.scriptAnswerId > 0) &&
                    (m.questionType != ScriptsQuestionType.None || (m.agentScriptDocuments && (!m.isSplitMessage || m.isLastSplitMessage))) &&
                    m.questionType !== ScriptsQuestionType.FullText) ||
                m.questionType === ScriptsQuestionType.AppointmentScheduler
            ) {
                // m.isLastSplitMessage: No typing indicator and delay required.
                if (
                    m.questionType == ScriptsQuestionType.MultipleChoiceConsent &&
                    m.isUnread
                ) {
                    me.showOptInConsentOverlay(m);
                }
                // m.isLastSplitMessage: No typing indicator and delay required.
                else if (
                    m.isLastSplitMessage ||
                    ApexChat.shouldContinueMapping ||
                    m.shouldRenderWithDelay
                ) {
                    // Apply disable when question type is quick reply - DISBALED
                    if (me.QTRendererExt.questionTypeRenderer.isQuestionTypeOptionsAvailable(m)) {
                        me.QTRendererExt.questionTypeRenderer.setVersion(
                            QuestionTypeVersion.RoundedDynamic
                        );

                        m.isGreeting = isGreetingMessageQuestionType;
                        // pass in a callback: afterRenderMessage
                        const alreadyMapped = null;
                        const isContinueMappingApplied = ApexChat.TryParse(
                            Cookies.get(TempCache.Continue_Mapping_Applied)
                        );
                        if (
                            me.options.chatMode == ChatMode.Windowed &&
                            !isContinueMappingApplied
                        ) {
                            // for windowed mode continue mapping should get from querystring
                            Cookies.set(TempCache.Continue_Mapping_Applied, true); // if continue mapping already run once we dont need to run again on windowed.
                            ApexChat.shouldContinueMapping = ApexChat.TryParse(
                                fromQueryString('shouldContinueMapping')
                            ); // fetch value of continueMapping from querystring.
                        }
                        m.shouldContinueMapping = ApexChat.shouldContinueMapping;
                        ApexChat.shouldContinueMapping = alreadyMapped;
                        await me.QTRendererExt.questionTypeRenderer.renderMessage(
                            m,
                            me.QTRendererExt.afterRenderMessage.bind2(me.QTRendererExt),
                            lastSplitMsgCallback
                        );
                    }
                } else {
                    logIt('DELAY::me.options.questionTypeDelay::OUT');

                    me.onTypingArrived({ indicator: true, participantDisplayName: m.participantDisplayName });
                    function processOnMessageArrived() {
                        logIt('DELAY::me.options.questionTypeDelay::IN:' + me.options.questionTypeDelay);
                        me.onTypingArrived({ indicator: false });
                        m.shouldRenderWithDelay = true;
                        me.onMessageArrived.call(me, m, initialLoad, index, lastSplitMsgCallback);
                    }
                    // omit timeout on initial load
                    if (initialLoad) {
                        processOnMessageArrived();
                    } else {
                        window.setTimeout(function () {
                            processOnMessageArrived();
                        }, (isGreetingMessageQuestionType ? 0.1 : me.options.questionTypeDelay) * 1000);//we need to literally omit questionTypeDelay in case of a QT greeting 
                    }
                    return;
                }
                me.hideTimeStampForPreviousMessages();
                me.autoScroll();
                me.notifyMessageHandled(m);
            } else {
                if (m.questionType == ScriptsQuestionType.WebToSMSNotification) {
                    me.handleWebToSmsNotification(m);
                }
                if (
                    m.questionType == ScriptsQuestionType.PhoneOTPDialog &&
                    m.isUnread
                ) {
                    me.handlePhoneOTP(m);
                }
                const shouldDisplayTypingIndicator = function (m) {
                    // This is the logical component which will take decison either to show Typing or not
                    // Show Typig only IF
                    const shouldBeQTType = m.scriptAnswerId > 0;
                    const shouldNotBeUserMessage = m.userId !== 0;
                    const shouldNotBeHistoryMessage = !initialLoad;
                    const shouldNotBeSplitPipedMessage = !m.isSplitMessage;
                    const shouldNotBeLastPipedMessage = !m.isLastPipedMessage;
                    const isQTNone = m.questionType === ScriptsQuestionType.None;
                    const isQTFullText = m.questionType === ScriptsQuestionType.FullText;
                    const shouldNotQTNoneFromPreChat = !(isQTNone && m.isFromPreChat);
                    return (
                        shouldBeQTType && // IF QTType AND
                        shouldNotBeUserMessage && // NOT User message AND
                        shouldNotBeHistoryMessage && // NOT Coming From History (Refresh Scenario) AND
                        shouldNotBeSplitPipedMessage && // NOT SplitMessage AND (i.e; Piped, we already have shown typing for this)
                        // (For QT - None |OR| QT - FullText) (ONLY)
                        shouldNotQTNoneFromPreChat && // Should not be QTNone From PreChat
                        (isQTNone || isQTFullText)
                    );
                };
                if (m.questionType === ScriptsQuestionType.VideoGreet) {
                    await me.QTRendererExt.questionTypeRenderer.renderMessage(
                        m,
                        me.QTRendererExt.afterRenderMessage.bind2(me.QTRendererExt),
                        lastSplitMsgCallback
                    );
                }
                me.showTypingIndicatorThenDisplayMessage({
                    indicatorDuration: me.options.questionTypeDelay * 1000,
                    shouldDisplayTypingIndicator: shouldDisplayTypingIndicator(m),
                    m,
                    onComplete(cb) {
                        logIt(`displaying msg:${m.text}`);
                        // Apply enable when question type is plain text- DISBALED for now
                        div.innerHTML = decodeHTML(content);
                        var shouldDisplayInChat = m.questionType !== ScriptsQuestionType.VideoGreet
                            && m.questionType != ScriptsQuestionType.WebToSMSNotification
                            && m.questionType != ScriptsQuestionType.PhoneOTPDialog;
                        if (shouldDisplayInChat) {
                            me.messagesContainer.append(div);
                        }
                        if (m.participantId === ParticipantIds.AIBot) {
                            me.getLastQuestionTypeForAIbot()
                        }

                        mqtMeta.msg = m;
                        mqtMeta.cb = lastSplitMsgCallback;
                        me.QTRendererExt.afterRenderMessage(mqtMeta);
                        const isContinueMappingApplied = ApexChat.TryParse(
                            Cookies.get(TempCache.Continue_Mapping_Applied)
                        );
                        if (
                            me.options.chatMode == ChatMode.Windowed &&
                            !isContinueMappingApplied &&
                            m.questionType === ScriptsQuestionType.FullText
                        ) {
                            Cookies.set(TempCache.Continue_Mapping_Applied, true); // if continue mapping already run once we dont need to run again on windowed.
                            let fullTextResponse =
                                fromQueryString('FullTextVisitorResponse'); // for fullText response send from prechat should render on windowed
                            fullTextResponse = fullTextResponse
                                ? window.decodeURI(fullTextResponse)
                                : fullTextResponse; // decoded value from query string to send correct response
                            ApexChat.FullTextVisitorResponse = ApexChat.TryParse(fullTextResponse); // set FullTextVisitor Response from query string.
                        }
                        if (
                            m.questionType === ScriptsQuestionType.FullText &&
                            ApexChat.FullTextVisitorResponse
                        ) {
                            const FullTextAnswer = ApexChat.TryParse(
                                ApexChat.FullTextVisitorResponse
                            )[0].option;
                            me.QTRendererExt.isLastFullTextValidated = true;
                            const customRes = {
                                chatId: m.chatId,
                                isSkipped: false,
                                answers: ApexChat.FullTextVisitorResponse,
                                msgText: FullTextAnswer,
                                agentScriptAnswerId: m.scriptAnswerId,
                                chatLogId: m.id,
                                questionTypeChatLogIdToBeUpdated:
                                    m.questionTypeChatLogIdToBeUpdated || 0
                            };
                            me.handleFullTextType({ res: customRes });

                            ApexChat.FullTextVisitorResponse = null;
                        }
                        if (!m.showTime) {
                            // Show time by force where needed.
                            me.hideTimeStampForPreviousMessages();
                        }
                        me.autoScroll();
                        me.getNotifyMessageHandler.call(me, m);
                        // with this callback parameter we can perform some function after onComplete
                        if (cb) {
                            cb();
                        }
                    }
                });
            }
            questionTypeId = ApexChat.storageAPI.Get('questionTypeId');
            // console.log(questionTypeId);
            // scroll to the bottom
            if (
                (m.scriptAnswerId > 0 && m.questionType != ScriptsQuestionType.None) ||
                m.questionTypeResponseChatLogId
            ) {
                me.autoScroll(questionTypeId);
            } else {
                me.autoScroll();
            }
            // parent method
            // me.$super('onMessageArrived', m);

            // Detect if the user is not looking at the chat window.
            // Show dialog box to bring the chat box on top
            // Limited to Window chats only
            if (
                me.options.chatMode == ChatMode.Windowed &&
                me.options.newMessageVisibility
            ) {
                newMessage = true;
                if (window.restartTimer && typeof window.restartTimer === 'function') {
                    // Make sure it starts counting only when a new message arrives
                    window.restartTimer();
                }
            }
            // after the first load, flash the title and play a sound
            // if ((!initialLoad && m.userId != 0) || (initialLoad && m.userId == TempCache.SIMULATED_AGENT_ID)) {
            //    me.playSound(Cookies.get('messageSound')); // JIRA_2905 - Play sound only for agent message. (Its cookie based for visitor-end incoming sound) and notifyMessage was using Dashboard sound cookie)
            // }
            m.initialLoad = initialLoad;
            me.state.changeState({
                origin: me.objectType,
                toState: ChatEvents.OnMessageIncoming,
                value: m
            });
            m.messagedHandled = true;
            me.postMessage({ event: 'chatui-message-arrived' });
            // TODO
            // ADACompliant.push(me.context.querySelector('.apexchat_ada_compliance')).apply();
            // note that we have some content
            me._hasMessages = true;
            if (
                me.options.model.chatMode == ChatMode.Windowed &&
                me.options.model.autoPushUrls
            ) {
                try {
                    const els = me.$('a', div);
                    for (let i = 0; i < els.length; i++) {
                        // we have to pick one, so we're going with the first that has an absolute url
                        if (els[i].href.indexOf('http') === 0) {
                            window.opener.location = els[i].href;
                            break;
                        }
                    }
                } catch (ex) {
                    if (console) {
                        console.error(ex);
                    }
                }
            }
        };
        try {
            await handleMessage(m);
        } catch (ex) {
            if (ApexChat.isInDevMode) {
                // helpful for v3-developer
                const exception = ex;
                logIt(exception.message, null, console.error);
            }
            // if, for whatever reason, the message arriving fails (for example, if the DOM isn't ready when a message shows up), then
            // we always want to just retry in a moment.
            let retryCount = 0;
            window.setTimeout(() => {
                if (retryCount < 10) {
                    retryCount++;
                    log(`${ex}! Retrying message arrived...`, LogLevel.Debug);
                    me.onMessageArrived(m, initialLoad, index);
                }
            }, 200);
        }
        // check if the message is docusign preview
        if (m.isDocuSignRequest) {
            // split text and URL
            const docusignMessage = m.text.split(',');
            // 0 index is the text and 1 index is the URL
            // generate HTML to be rendered
            const wrapHTML = `<a href="${docusignMessage[1]}" class="docusign_action_button docusign_action_button_bg" target="_blank">${docusignMessage[0]}</a>`;
            // get the current message wrapper
            const messageWrapper = me.$(`#apexchat_chatlog_${m.id}`, me.context);
            // add docusign specific class to wrapper
            messageWrapper.addClass('docusign-container');
            // replace HTML
            messageWrapper.html(wrapHTML);
        }
        var textBox = me.$('#apexchat_rd_msg_box, #frmAutocomplete input', me.options.context);
        if (textBox && textBox.length > 0) {
            if (m.questionType === ScriptsQuestionType.FullText) {
                textBox.addClass('apexchat_full_text');
            } else {
                textBox.removeClass('apexchat_full_text');
            }
        }
        me.handleDateTimeDOBMessage();
        // me.handleAttachmentButtonVisibility(m);
    }
    getLastQuestionTypeForAIbot() {
        let me = this;
        let scriptId = Cookies.get('lastMessageAnswerId');
        if (scriptId) {
            const xhr = new XMLHttpRequest();
            xhr.open(
                'GET',
                `${GlobalVariables.LiveChatServiceUrl
                }Handlers/SendQuestionToVisitorHandler.ashx?questionId=${scriptId}&chatId=${me.getChatId()}`
            );
            xhr.send();
            me.autoScroll();
            ApexChat.AIResponseReceived = true;
        }
    }
    removeSMSToWebNotification() {
        var me = this;
        me.$('.apexchat_rd_transfer_to_sms', me.context).hide();
        var $wrapper = me.$('#apexchat_rd_chat_content', me.context);
        if ($wrapper && $wrapper.length === 0) {
            $wrapper = me.$('#apex-transcript', me.context);
        }
        $wrapper.unbind('scroll');
        $wrapper.css({
            paddingBottom: 0,
            paddingTop: 0,
            transition: "none",
            boxSizing: "initial",
        });
    }
    handleWebToSmsNotification(msg) {
        const me = this;
        if (!msg.isUnread) {
            return;
        }
        var chatLogId = msg.id;
        me.savePhoneNumber(msg.maskedText);
        RunAsSoonAs(function () {
            if (me.options.msg && me.options.msg.isSmsTransfer) {
                var phonemsg = me.getPhoneMessage();
                var namemsg = getNameMessage();
                var smsForm = WebSmsFormValidator(me.options);
                smsForm.init();
                smsForm.getWebSmsService({
                    initiatedBy: me.options.chatInitiatedBy,
                    phone: phonemsg.phone,
                    visitorName: namemsg.name,
                    interceptorResults: me.options.interceptorResult,
                    chatId: GetChatID(me.options),
                    chatLogId: chatLogId,
                    serviceUrl: '/Handlers/ConvertToSMSHandler.ashx'
                }, function () { });
            }
        }, function () {
            var msgsList = me.$('[chatlogid] ', me.context).toArray().reverse();
            var cleaningRegex = /(^[^\w()]+)|([^\w()]+$)/g;
            var cleanedMaskedText = msg.maskedText.replace(cleaningRegex, '');
            var phoneMsgRendered = msgsList.find(x => me.$(me.$(x, me.context).find('p.apexchat_rd_msg_text', me.context)[0], me.context).text().replace(cleaningRegex, '') == cleanedMaskedText);
            if (phoneMsgRendered) {
                var renderedmsgChatlogId = me.$(phoneMsgRendered, me.context).attr('chatlogid');
                if ((renderedmsgChatlogId > chatLogId) || (renderedmsgChatlogId < 0 && !me.isFirstNotificationRendered)) {
                    me.isFirstNotificationRendered = true;
                    return true;
                }
                return false;

            }
        });
    }
    handlePhoneOTP(msg) {
        var me = this;
        if (!msg.isUnread) {
            return;
        }
        var wrapper = document.createElement('div');
        wrapper.id = 'livechat_phone_otp_overlay';
        wrapper.className = 'apexchat_overlay apexchat_optin_concent';
        if (msg.maskedText) {
            me.savePhoneNumber(msg.maskedText);
        }
        me.showOverlayWithAction(
            wrapper,
            me.getPhoneOTPHtml({ text: msg.text }),
            function () {
                // add show class to sms opt in parent div
                // after it's been loaded to the dom
                me.$('#livechat_phone_otp_overlay', me.context).wrap(
                    '<div id="livechat_phone_otp_overlay_wrapper"></div>'
                );
                RunAsSoonAs(
                    function () {
                        me.$('#livechat_phone_otp_overlay', me.context).addClass(
                            'livechat_phone_otp_show'
                            // 'apexchat_optin_concent_show'
                        );
                    },
                    function () {
                        return me.$('#livechat_phone_otp_overlay', me.context).is(':visible');
                    }
                );
                me.options.chatLogId = msg.id;
                var otpHandler = PhoneOTPHandler(me.options);
                var phonemsg = me.getPhoneMessage();
                otpHandler.init();
                otpHandler.bind(phonemsg.phone);

            },
            true
        );
        // me.togglePhoneOTPBottomSheet();
    }
    getCSSSelectorForRDThemeTimeStamp(id) {
        return `.apexchat_auto_genned_message_wrapper[chatlogid|=${id}] .apexchat_rd_timer_span`;
    }

    getCSSSelectorForRDThemeToolTip(id) {
        return `.apexchat_auto_genned_message_wrapper[chatlogid|=${id}] .apexchat_tooltip_container`;
    }

    hideTimeStampForPreviousMessages() {
        const me = this;
        // This new feature is only for V3-RDTheme
        if (!me.options.isRoundedDynamic) {
            return;
        }
        for (let i = 0; i < me.chatLogArray.length; i++) {
            // IF the current message is Visitor Response we need to apply some logic
            if (
                me.chatLogArray[i].isVisitorResponse &&
                me.chatLogArray[i - 1] &&
                me.chatLogArray[i - 1].isVisitorResponse
            ) {
                // Current Message = Visitor Response
                // 1- Hide the TimeStamp of Previous message (If any).
                // me.$(
                //     me.getCSSSelectorForRDThemeTimeStamp(me.chatLogArray[i - 1].id),
                //     me.context
                // ).hide();
                // // 2- Show the ToolTip of Previous message (if any).
                // me.$(me.getCSSSelectorForRDThemeToolTip(me.chatLogArray[i - 1].id), me.context)
                //     .removeClass('livechat_hide_with_opacity')
                //     .addClass('livechat_show_with_opacity');
                // // 3- Hide the ToolTip of Current Message.
                // me.$(me.getCSSSelectorForRDThemeToolTip(me.chatLogArray[i].id), me.context)
                //     .removeClass('livechat_show_with_opacity')
                //     .addClass('livechat_hide_with_opacity');
            }
            if (
                !me.chatLogArray[i].isVisitorResponse &&
                me.chatLogArray[i - 1] &&
                !me.chatLogArray[i - 1].isVisitorResponse
            ) {
                // Current Message = Agent Response
                // 1- Hide the TimeStamp of Previous message (If any).
                // me.$(
                //     me.getCSSSelectorForRDThemeTimeStamp(me.chatLogArray[i - 1].id),
                //     me.context
                // ).hide();
                // // 2- Show the ToolTip of Previous message (if any).
                // me.$(me.getCSSSelectorForRDThemeToolTip(me.chatLogArray[i - 1].id), me.context)
                //     .removeClass('livechat_hide_with_opacity')
                //     .addClass('livechat_show_with_opacity');
                // // 3- Hide the ToolTip of Current Message.
                // me.$(me.getCSSSelectorForRDThemeToolTip(me.chatLogArray[i].id), me.context)
                //     .removeClass('livechat_show_with_opacity')
                //     .addClass('livechat_hide_with_opacity');
            }
            // General Rule: Hide the Tooltip of current message because we will show TimeStamp of current message not ToolTip.
            me.$(me.getCSSSelectorForRDThemeToolTip(me.chatLogArray[i].id), me.context)
                .removeClass('livechat_show_with_opacity')
                .addClass('livechat_hide_with_opacity');
        }
    }

    showTypingIndicatorThenDisplayMessage(params) {
        const me = this;
        const { m } = params;

        if (!params.shouldDisplayTypingIndicator) {
            params.onComplete();
            return false;
        }
        logIt('DELAY::showTypingIndicatorThenDisplayMessage');

        me.onTypingArrived({
            indicator: true,
            participantDisplayName: m.participantDisplayName
        });

        // display messages async
        setTimeout(() => {
            logIt(`DELAY::params.indicatorDuration:${params.indicatorDuration}`);

            logIt('NONE:: started processing msg:');
            me.onTypingArrived({ indicator: false });
            if (params.onComplete) {
                params.onComplete(() => {
                    // do whatever required after msg has completely been processed
                    // setTimeout(function () {
                    // clearTimeout(timeout);
                    // }, 1000);
                    me.counterForQueuedTimers = 0; // reset counter
                });
            }
        }, params.indicatorDuration * ++me.counterForQueuedTimers);

        logIt(`NONE:: ApexChat.counterForQueuedTimers:${me.counterForQueuedTimers}`);

        return true;
    }

    isGreetingQuestionType(m, index) {
        /* Checking if it is first message and it is QuestionType then return true ,
         * greeting message comes with index == 0 , so we test here that if index is 0 so its a greeting message.
         * */
        if (m.scriptAnswerId && m.questionType && m.options && index == 0) {
            TempCache.IS_GREETING_QUESTIONTYPE = true;
            return true;
        }
        if (m.userId != TempCache.AUTOGREET_AGENT_ID && !m.isGreeting) {
            TempCache.IS_GREETING_QUESTIONTYPE = false;
            return false;
        }
        return false;
    }

    checkChatRoomLoaded(cb) {
        const me = this;
        var checkingInterval = setInterval(() => {
            if (!me.isChatroomAlive()) {
                me.loadChatRoom();
            } else {
                cb();
                clearInterval(checkingInterval);
            }
        }, 300);
    }

    sendMsgWhenChatroomAvailable() {
        const me = this;
        var checkingChatRoom = setInterval(() => {
            if (me.isChatroomAlive()) {
                me.sendMessage();
                clearInterval(checkingChatRoom);
                // we must bind back after 1st msg
                // me.clickButton.click(me.sendMessage.bind2(me));
            }
        }, 200);
    }

    transferChatWhenChatroomAvailable() {
        const me = this;
        var checkingChatRoom = setInterval(() => {
            if (me.isChatroomAlive()) {
                me.publishPredefinedMessages(() => {
                    me.startWaiting();
                    me.room.sendLive();
                    me.preserveChatArray = []; // clear
                    me.enableChatTransfer().then(_ => {
                        me.transferChat();
                    });
                });
                clearInterval(checkingChatRoom);
            }
        }, 200);
    }

    isChatroomAlive() {
        const me = this;
        return me.room && me.room.isConnectionEstablished;
    }

    sendTyping(e) {
        const me = this;
        let text = []; // assign empty array
        // reset waiting when the visitor is typing
        try {
            const $txt = me.$(me.messageInput, me.context);
            logIt(`input text:${$txt.val()}`);
            TempStorageCache.add(TempCache.INPUT_OLD_VALUE, $txt.val(), true); // cache input value as it is typed
        } catch (err) {
            // ignore it
            logIt(`error caching input text:${err.message}`);
        }
        logIt('BASE::sendTyping');
        let c = e.which;
        // normalize keyCode
        if (To_ascii.hasOwnProperty(c)) {
            c = To_ascii[c];
        }
        // small case letters
        if (!e.shiftKey && c >= 65 && c <= 90) {
            c = String.fromCharCode(c + 32);
        } else if (e.shiftKey && shiftUps.hasOwnProperty(c)) {
            c = shiftUps[c];
        } else {
            c = String.fromCharCode(c);
        }
        // push all entries into the text array
        text.push(c);
        // send the message after 15 chars are entered
        if (text.length == 15 && e.keyCode == 32) {
            // on spacebar press we are sending typing indcator
            me.room.sendTyping(true, text.join(''));
            // reset the array
            text = [];
        }
        // else just send the indicator signal with no text
        else if (!me.typing && e.keyCode == 32) {
            me.typing = true;
            me.room.sendTyping(true);
        }
        window.clearTimeout(me.timeout);
        me.timeout = window.setTimeout(() => {
            if (me.room) {
                me.typing = false;
                me.room.sendTyping(false);
            }
        }, TempCache.IDLE_TYPING_THRESHOLD * 1000);
    }

    onMessageTyping(e, el) {
        const me = this;
        // reset waiting when the visitor is typing
        try {
            const $txt = me.$(el || me.messageInput, me.context);
            logIt(`input text:${$txt.val()}`);
            TempStorageCache.add(TempCache.INPUT_OLD_VALUE, $txt.val(), true); // cache input value as it is typed
        } catch (err) {
            // ignore it
            logIt(`error caching input text:${err.message}`);
        }
        try {
            me.isUserTyping = true;
            let text = [];

            if (isEnterKeyPressed(e)) {
                if (!me.room && !me.allowSendMessageWithoutChatroom) {
                    me.loadChatRoom();
                    me.sendMsgWhenChatroomAvailable();
                } else {
                    TempCache.IS_GREETING_QUESTIONTYPE = false;
                    me.sendMessage(el);
                    window.clearTimeout(me.timeout);
                    me.typing = false;
                    me.room.sendTyping(false);
                    e.preventDefault();
                    text = [];
                }
            } else if (me.room) {
                me.sendTyping(e);
            }
        } catch (ex) {
            console.log(ex.message);
        }
    }

    sendButtonDisableOrEnableForATA(txt) {
        var me = this;
        var msg = me.options.msg || '';
        if (msg) {
            if (
                !msg.questionTypeDisplayListForVisitor &&
                !me.isBottomSheetSupported &&
                me.options.msg.questionType == ScriptsQuestionType.AllThatApply
            ) {
                var v = txt.val().trim();
                if (!v || v.replace(/\s/g, '') === '' || v == txt.attr('title')) {
                    Utils.disableElement(me.clickButton, { applyGrayBackground: true });
                    return;
                }
                Utils.enableElement(me.clickButton, { applyGrayBackground: false, recursively: true })
            }
        }
    }

    onLiveArrived(liveChat) { }

    onChatJoinFailure(args) {
        window.clearInterval(this._countDownInterval);
        const me = this;
        if (me.introContainer) {
            me.introContainer.html(args.error);
        } else {
            alert(args.error);
        }
    }

    onChatJoined(args) { }

    sendMessage(textInput) {
        textInput = escapeHTML(textInput);
        TempCache.IS_GREETING_QUESTIONTYPE = false;
        const me = this;
        if (!me.isChatroomAlive()) {
            return;
        }
        // CHAT-7003, CHAT-7004, CHAT-7005: validate FullText
        if (me.QTRendererExt && me.QTRendererExt.isLastMessageFullText()) {
            me.QTRendererExt.validateFullTextMessage(textInput); // just validate and return
            return; // we are separately handling Fulltext scenario in handleFullTextType()
        }
        logIt(`EP::BASE:sendMessage::msg:${textInput}`);

        me.startWaiting();
        me.room.sendLive();
        me.showTyptingIndicatorForAIBot(me);
        me.room.sendMessage({
            chatMsg: textInput,
            isForAIBot: me.options.model.aiBotEnabled,
            callback() {
                // after sending msg to dashboard do something
            }
        });
    }
    showTyptingIndicatorForAIBot(me) {
        if (me.options.model.aiBotEnabled && !me.isTransferredToLiveAgent() && !me.room?.isChatEnded) {
            ApexChat.AIResponseReceived = false;
            RunUntil(() => {
                console.log('waiting for AI response...' + ApexChat.AIResponseReceived);
                me.onTypingArrived({
                    indicator: true,
                    participantDisplayName: me.options.model.agentName
                });
            }, 1000, () => {
                if (ApexChat.AIResponseReceived) {
                    me.$('.apexchat_rd_chat_typing', me.context).hide();
                    me.$('apexchat_rd_ep_typing', me.context).hide();
                }
                return ApexChat.AIResponseReceived;
            });
        }
    }
    minimize() {
        this.hide();
    }

    maximize() {
        // JIRA_4190 - the setChatId function is no more needed because loadChatRoom we are calling seperately.
        // this.options.chatModel = ApexChatStartData;
        // this.room.setChatId(this.options.chatModel.chatId);
    }

    popOut() {
        // var me = this;
        // this.hide();
        // this.options.chatInitiatedBy = 'ExitPopup';
        // this.startWindowedChat(me.options);
        this.postMessage({
            event: this.objectType + WidgetStates.PoppedOut
        });
    }

    hide() {
        const me = this;
        me.$(me.container, me.context).hide();
    }

    loadChatRoom(cb) {
        const me = this;
        if (me.room) {
            return;
        }

        try {
            RunAsSoonAs(
                () => {
                    // initializing the analytics object before starting the chat due to unavailability of ga object in windowed chat widget.
                    googleAnalyticsObjectInit('gat');
                    me.room = new LiveChatRoom(Object.assign(me.options, me.options.model));
                    me.room.initChatRoom();
                    me.options.chatModel = ApexChatStartData;
                    me.room.setChatId(me.options.chatModel.chatId, me.options.chatModel.token);
                    me.room.setNewChat(me.options.chatModel.isNewChat);
                    // track the time from when the click was triggered (stored in the 'cb' variable) to when we render the UI
                    const clickTime = me.getRequestedTime(); // TODO: dbl check this is right way
                    const endTime = new Date().getTime();
                    const timeSpent = endTime - clickTime;
                    // logIt('DOM loading time is:' + timeSpent);
                    // track that we've shown the UI
                    me.state.changeState({
                        origin: me.objectType,
                        toState: me.state.getStateValue(WidgetTypes.DOMUIController),
                        value: timeSpent
                    });
                    // do wahtever caller wants to after this piece is done
                    if (cb) {
                        cb();
                    }
                    if (!Cookies.get(TempCache.SUBSEQUENT_GREETING_COOKIE)) {
                        Cookies.setShortMinutes(
                            TempCache.SUBSEQUENT_GREETING_COOKIE,
                            true,
                            me.options.model.reShowIntervalMinutes
                        );
                    }
                },
                () => {
                    const isChatRoomV3Loaded = typeof LiveChatRoom !== 'undefined'; // check if LiveChatRoom loaded
                    logIt(`CV3::isChatRoomV3Loaded:${isChatRoomV3Loaded}`);
                    const checkApexChatStartDataExists =
                        typeof ApexChatStartData !== 'undefined' && ApexChatStartData != null; // check when ApexChatStartData declared in current context and also check null
                    return isChatRoomV3Loaded && checkApexChatStartDataExists;
                }
            );
        } catch (err) {
            console.log(err);
        }
    }

    show(state /** _min or _max? */) {
        const me = this;
        me.reposition();
        me.bind(state);
    }

    async end() {
        if (this.isChatActive()) {
            const me = this;
            me.askConfirmation({
                message: GlobalVariables.ChatCloseWarningMessage,
                flag: me.options.model.enableChatWindowCloseWarning,
                callback() {
                    me.endChatSession();
                }
            });

        } else {
            this.endChatSession();
        }
        const module = await import(/* webpackChunkName: "questionTypeRendererFactory" */ '../questiontypes/QuestionTypeRendererFactory')
        new module.default().destroy();
    }

    autoScroll(id) {
        // allow a scroller to be set independant of the message container
        // arrived...
        const me = this;
        if (!id) {
            const scroller = me.$(this.options.elements.scrollerSelector, me.context);
            if (scroller.length) {
                scroller.prop('scrollTop', scroller.prop('scrollHeight'));
            } else if (this.messagesContainer) {
                this.messagesContainer.scrollTop = this.messagesContainer.scrollHeight

            }
        } else {
            // var idHeight = $('#apexchat_chatlog_' + id).offset().top;
            // if (this.messageContainer) {
            //    this.messageContainer.prop('scrollTop', idHeight);
            // }
            if (/iPhone/.test(navigator.platform) || /Android/i.test(navigator.userAgent)) {
                var target = me.context.getElementById(`apexchat_chatlog_${id}`);
                // target.parentNode.scrollTop = target.offsetTop;
                if (target) {
                    scrollIntoView(target);
                }
            } else {
                var target = me.context.getElementById(`apexchat_chatlog_${id}`);
                if (target) {
                    target.scrollIntoView(true);
                }
            }
        }
    }

    playSound(soundName) {
        const me = this;
        RunAsSoonAs(
            () => {
                if (getStorageAPIValue(TempCache.CHAT_SOUND_ENABLED) != 'false') {
                    if (me.oneTimeSoundSetup) {
                        soundManager.setup({
                            url: `${GlobalVariables.ApexChatBaseUrl}scripts/libraries/soundmanager2/swf/`,
                            flashVersion: 9,
                            preferFlash: false, // prefer 100% HTML5 mode, where both supported
                            onready() {
                                // console.log('SM2 ready!');
                            },
                            ontimeout() {
                                // console.log('SM2 init failed!');
                            },
                            defaultOptions: {
                                // set global default volume for all sound objects
                                volume: GlobalVariables.visitorEndSoundVolume

                            }
                        });
                        // JIRA_3188 - 23JAN18 - START (dev: Mahad) - Error in console due to Sound flooding
                        // summmary: Actual bug: When agent from dashboard was floods message the visitor-end visitor was receiving sound flood,
                        // in this case, Im preventing Sound to be played but just one time in 5seconds.
                        GlobalVariables.timeIntervalSoundFlood = setInterval(() => {
                            GlobalVariables.avoidSoundFlooding++; // I introduced this setInterval which will count seconds.
                            if (GlobalVariables.avoidSoundFlooding > 30) {
                                // for best practice we are clearing this setInterval after 30seconds, so user's page will not get slow.
                                me.oneTimeSoundSetup = true; // I'm reseting this oneTimeSoundSetup so this scope will run again on agent's response.
                                GlobalVariables.avoidSoundFlooding = 0; // resetting seconds counter.
                                clearInterval(GlobalVariables.timeIntervalSoundFlood); // Finally clearing the interval.
                            }
                        }, 1000);
                        // JIRA_3188 - 23JAN18 - END
                    }
                    const playSound =
                        me.allowSoundFloodingOnNewMesssage ||
                        (!me.allowSoundFloodingOnNewMesssage && GlobalVariables.avoidSoundFlooding > 5);
                    if (me.oneTimeSoundSetup || playSound) {
                        // this code will only run when agent's first response or his response after 5sec.
                        // means if agent send 2 response simultaneously within 5sec this code will play sound only one time.
                        const _sound = soundManager.createSound({
                            id: soundName,
                            url: `${GlobalVariables.ApexChatBaseUrl}Contents/media/${soundName}.mp3`,
                            volume: GlobalVariables.visitorEndSoundVolume,
                            onload() {
                                console.log(`${this.id} loaded.`);
                            },
                            onplay() {
                                console.log(`Starting sound: ${this.id}`);
                            },
                            autoPlay: false,
                            autoLoad: true,
                            stream: true
                        });
                        _sound.play();
                        GlobalVariables.avoidSoundFlooding = 0; // resetting seconds counter.
                    }
                    me.oneTimeSoundSetup = false; // preventing oneTimeSoundSetup to load again and again.
                }
            },
            () => typeof window.soundManager !== 'undefined'
        );
    }

    playSoundEPPredefinedMessage(soundName) {
        RunAsSoonAs(
            () => {
                if (getStorageAPIValue(TempCache.CHAT_SOUND_ENABLED) != 'false') {
                    soundManager.setup({
                        preferFlash: false,
                        url: `${GlobalVariables.ApexChatBaseUrl}scripts/libraries/soundmanager2/swf/`,
                        defaultOptions: {
                            volume: GlobalVariables.visitorEndSoundVolume

                        }
                    });
                    setTimeout(() => {
                        // using this setTimeout for 1000 =1sec, for downloading that .mp3 file.
                        soundManager.createSound({
                            id: soundName,
                            url: `${GlobalVariables.ApexChatBaseUrl}Contents/media/${soundName}.mp3`,
                            volume: GlobalVariables.visitorEndSoundVolume

                        });
                        soundManager.play(soundName, {
                            onfinish() { }
                        });
                    }, 1000);
                }
            },
            () => typeof window.soundManager !== 'undefined'
        );
    }

    notifyNewMessageArrived(allowflooding) {
        const me = this;
        me.allowSoundFloodingOnNewMesssage = allowflooding;
        ApexChatTitle.flash();
        const soundName =
            Cookies.get(VISITOR_MESSAGE_SOUND.name) ||
            VISITOR_MESSAGE_SOUND.tune;
        me.playSound(soundName);
    }

    reposition() {
        const me = this;
    }

    syncSize(cb) {
        const me = this;
        const container = me.$('html');
        const diff = me.$(window).height() - container.height();
        const current = me.$('.livechat_messages').height();
        let target = current + diff;
        if (target < 80) {
            target = 80; // cutoff
        }
        me.$('.livechat_messages').css({ height: `${target}px` });
        // extend the window horizontally
        me.$('.apexchat_windowed').css({ width: '95%' });
        // hide the scroll bars
        me.$('.apexchat_loaded').css({ overflow: 'hidden' });
        if (cb && typeof cb === 'function') {
            cb();
        }

        // added this code to adjust height on android when keyboard is on/off
        const { isDefaultMobileTheme } = me.options;
        if (
            /Android/i.test(navigator.userAgent) &&
            me.options.chatMode == ChatMode.Windowed &&
            isDefaultMobileTheme
        ) {
            setTimeout(() => {
                me.$('.livechat_messages').css({ height: '100%' });
                // scroll to show latest message to user
                if (me.$('#apexchat_chatMsg_textbox').is(':focus')) {
                    me.autoScroll();
                }
            }, 150);
        }
    }

    clickSourceClick() {
        // log that it was clicked
        ServerLog.trackClick({
            companyId: this.options.companyId,
            visitorId: this.options.visitorId,
            clickSource: 'chatroom'
        });
    }

    hideWaitingIndicator(participants) {
        const me = this;
        if (me.options.model.chatheadertemplate) {
            if (me.introcontainer) {
                me.introcontainer.hide();
            }
            me.options.model.chatheader = parsetemplate(
                me.options.model.chatheadertemplate,
                me.options.model || me.options
            );
            if (me.participantscontainer) {
                me.participantscontainer.html(me.options.model.chatheader);
            }
        }
        me._participantsHasBeenGreaterThanOne = true;
    }

    getNotifyMessageHandler(m) {
        const me = this;
        if (
            (me.widget === WidgetTypes.EPUIController && // 1- for EP only
                m.isPredefinedMessage &&
                m.isLastSplitMessage) || // Send notification for rendering the last part of predefined pipe message
            (m.isPredefinedMessage && m.questionType == ScriptsQuestionType.None)
        ) {
            // Notify the subscriber that Plain text predefined message has been rendered
            return me.notifyPredefinedMessageRendered(m);
        }
        return me.notifyMessageHandled(m);
    }

    /**
     * notifies subscribers that a message has been either completely rendered or handled; the 2 subscribers are:
     * 1. EP Predefined Queue: for 1st time or reload scenarios
     * 2. chatroom-v3 Queue: for refresh/history scenario
     */
    notifyMessageHandled(m) {
        const me = this;
        const restartChatOption =
            ((me.QTRendererExt &&
                me.QTRendererExt.lastMessage &&
                me.QTRendererExt.lastMessage.isChatEnded) ||
                me.isTransferredToLiveAgent());
        if (restartChatOption) {
            me.adjustRdActionMenu(); // This function hides or shows the restart option/button in dropdown/header when either live chat is transferred to live agent or the chat is ended
        }
        // 2- in case of reload/history, a piped messagebut only if its last split message
        const isNotLastSplitMsg = m.isSplitMessage && !m.isLastSplitMessage;
        if (isNotLastSplitMsg) {
            // we bail out for a split msg in normal chat msgs
            return;
        }
        if (!m.isFromHistory) {
            // we bail out for a normal chat msg;i.e. not coming from history
            return;
        }
        // we only come here for either 1- predefined last split messages or 2- all history messages but only last split message (in case of a piped one)

        setTimeout(() => {
            logIt(`after::${ChatStates.MessageArrived}:${m.text}`);
            me.postMessage({
                event: ChatStates.MessageArrived,
                data: m
            }); //
        }, 100);
    }

    notifyPredefinedMessageRendered(m) {
        const me = this;
        setTimeout(() => {
            logIt(`after::predefined-message-completed: ${m.text}`);
            me.postMessage({ event: 'predefined-message-completed', data: m }); //
        }, 100);
    }

    enableTypingInputOnServerResponse(emptyField) {
        const me = this;
        // enable the input field again, we block input field on sending
        // a message to server, to avoid duplication CHAT-8369
        if (me.options.scriptBotEnabled && !me.isTransferredToLiveAgent()) {
            $txt = me.$('#apexchat_rd_msg_box', me.options.context);
            if (emptyField) {
                $txt.val('');
            }
            enableTypingInput.bind2(me)(me, me.options.elements.inputContainerSelector);
        }
    }

    restartVAChat() {
        const me = this;
        me.state.changeState({
            toState: ChatEvents.OnChatRestart,
            value: true
        });
    }

    transferChat() {
        const me = this;
        me.state.changeState({
            toState: ChatEvents.OnTransferRequested,
            value: true
        });
    }

    initAgentNotFoundOverlay(targetSelector) {
        const me = this;
        me.targetSelector = targetSelector;
        if (
            !me.options.model.scriptBotEnabled ||
            !(true)
        ) {
            return;
        }
        // we keep this instance of agentNotFoundOverlay so we don't need tore-render every time
        me.agentNotFoundOverlayView = new SimpleView({
            identifier: 'livechat_agent_not_found_overlay',
            context: me.context,
            renderOninit: 'false',
            model: { baseUrl: GlobalVariables.ApexChatBaseUrl },
            style: [],
            template: noAgentAvailable({}),
            targetElementSelector: me.targetSelector,
            wrap: true,
            afterRender() {
                // var reinit = me.reInitializeChat.bind2(me, '.apexchat_chat_restart_wrapper', 'Restarting chat...');
                // var endChatAndstartNewChat = me.endChat.bind2(me, reinit);
                // to bring focus on restartchat and cancel buttons of overlay.
                ManageFocusOnKeyEvents(me.context.querySelector('.apexchat_btn_primary', me.context));
                // ManageFocusOnKeyEvents(me.$('.apexchat_btn_default', me.context));
                // now bind events: reInit and close
                me.ADAHandler(me.context.querySelector('.apexchat_btn_primary'), () => {
                    // endChatAndstartNewChat();
                    me.hideReInitOverlay('#apexchat_chat_restart_overlay');

                    // reset state
                    me.state.changeState({
                        toState: ChatStates.UIRendered
                    });
                });
                me.$('.apexchat_btn_primary', me.context).bind('click', () => {
                    me.postMessage({
                        event: WidgetTypes.PokeMessagesOverLay + WidgetStates.Hidden
                    });
                    me.hideReInitOverlay('#livechat_agent_not_found_overlay');
                    Cookies.set(TempCache.SHOW_OPERATOR_NOT_FOUND_OVERLAY, false);
                    // reset state
                    me.state.changeState({
                        toState: ChatStates.UIRendered
                    });
                });
                me.$('.apexchat_rd_chat_window_mode', me.context).addClass('apexchat_modal_opened');
                const _hideOverlay = function (overlaySelector) {
                    me.$(overlaySelector, me.context).hide();
                    me.state.changeState({
                        toState: ChatStates.UIRendered
                    });
                };
                me.ADAHandler(me.context.querySelector('.apexchat_btn_default'), () => {
                    _hideOverlay('#apexchat_chat_restart_overlay');
                });
                me.$('.apexchat_btn_default', me.context).bind('click', () => {
                    _hideOverlay('#apexchat_chat_restart_overlay');
                });
            }
        });
    }

    initRestartOverlay() {
        const me = this;
        if (!me.options.model.scriptBotEnabled) {
            return;
        }
        // we keep this instance of restartOverlay so we don't need tore-render every time
        me.restartOverlayView = new SimpleView({
            identifier: 'apexchat_chat_restart_overlay',
            context: me.context,
            renderOninit: 'false',
            model: { baseUrl: GlobalVariables.ApexChatBaseUrl },
            style: [],
            template: ImportRestartChatOverlayFactory().VAChatRestartOverlayTemplate(me.options.model),
            // VAChatRestartOverlay(me.options.model),
            targetElementSelector: me.isRDEP() ? '.apex-col-2' : '#apexchat',
            wrap: true,
            afterRender() {
                const reinit = me.reInitializeChat.bind2(
                    me,
                    '.apexchat_chat_restart_wrapper',
                    'Restarting chat...'
                );
                const endChatAndstartNewChat = me.endChat.bind2(me, reinit);
                // to bring focus on restartchat and cancel buttons of overlay.
                ManageFocusOnKeyEvents(me.context.querySelector('.apexchat_btn_primary'));
                ManageFocusOnKeyEvents(me.context.querySelector('.apexchat_btn_default'));
                // now bind events: reInit and close
                me.ADAHandler(me.context.querySelector('.apexchat_btn_primary'), () => {
                    endChatAndstartNewChat();
                    if (me.isRDEP()) {
                        me.startNewChatForEP();
                    }
                    me.hideReInitOverlay('#apexchat_chat_restart_overlay');
                    // reset state
                    me.state.changeState({
                        toState: ChatStates.UIRendered
                    });
                });
                me.$('.apexchat_btn_primary', me.context).bind('click', () => {
                    me.postMessage({
                        event: WidgetTypes.PokeMessagesOverLay + WidgetStates.Hidden
                    });
                    endChatAndstartNewChat();
                    if (me.isRDEP()) {
                        me.startNewChatForEP();
                    }
                    me.hideReInitOverlay('#apexchat_chat_restart_overlay');
                    // reset state
                    me.state.changeState({
                        toState: ChatStates.UIRendered
                    });
                });
                me.$('.apexchat_rd_chat_window_mode', me.context).addClass('apexchat_modal_opened');
                const _hideOverlay = function (overlaySelector) {
                    me.$(overlaySelector, me.context).hide();
                    me.state.changeState({
                        toState: ChatStates.UIRendered
                    });
                };
                me.ADAHandler(me.context.querySelector('.apexchat_btn_default'), () => {
                    _hideOverlay('#apexchat_chat_restart_overlay');
                });
                me.$('.apexchat_btn_default', me.context).bind('click', () => {
                    _hideOverlay('#apexchat_chat_restart_overlay');
                });
            }
        });
    }

    initVideoGreetOverlay() {
        var me = this;
        if (me.options.model && !me.options.model.videoGreetEnabled) {
            return;
        }
        //we keep this instance of restartOverlay so we don't need tore-render every time
        me.videoGreetOverlayView = new SimpleView({
            identifier: 'apexchat_chat_video_greet_overlay',
            context: me.context,
            renderOninit: 'false',
            template: VideoGreetOverlay({ baseUrl: GlobalVariables.ApexChatBaseUrl }),
            model: { baseUrl: ApexChatBaseUrl },
            style: null,
            targetElementSelector: me.isRDEP() ? '.apex-col-2' : '#apexchat', // the overly will append on this element
            wrap: true,
            afterRender: function () {
                me.loadVideoGreet()
            }
        });
    }
    loadVideoGreet() {
        var me = this;
        me.options.videoGreetSeekbar = '#apexchat_greet_video_overlay_seekbar';
        me.options.videoGreetPlayTrigger = '#apexchat_greet_video_play';
        me.options.videoGreetPlayPauseIcon = '#play_pause_icon';
        me.options.playerElementId = 'overlay_greet_video_player';
        me.options.vimeoScriptID = 'vimeo_js_overlay';
        me.options.videoGreetMuteTrigger = '#apexchat_greet_video_mute';
        me.options.vimeoPlayerConfig = {
            id: me.options.videoGreet.videoGreetURL,
            width: 300,
            loop: false,
            controls: false,
            byline: false,
            title: false,
            muted: false,
            autoplay: true,
            background: true,
        };

        if (!ApexChat.Vimeo2 && me.options.videoGreet.videoGreetURL) {
            me.setupVideoGreetVimeoPlayer();
        }
    }
    setupVideoGreetVimeoPlayer() {
        var me = this;
        const videoTemplate = `<video-js id="video-greet-pl" autoplay muted loop preload="auto">
                                <source src="${me.options.vimeoPlayerConfig.id}manifest/video.m3u8"
                                type="application/x-mpegURL" />
                              </video-js>`;

        const lazyLoadCss = getStyleForIframe(
            `https://vjs.zencdn.net/8.16.1/video-js.css`,
            "apexchat_Iframe_videogreet",
            me.options.iframeId || me.options.model.iframeId || 'apexchat_browser_chatwindow_max'
        );
        me.context.getElementById(
            "overlay_greet_video_player"
        ).innerHTML = videoTemplate;

        var player = me.context.getElementById("video-greet-pl");
        const options = {
            controls: false,
            autoplay: true,
            preload: 'auto',
            fill: true,
            muted: true,
            playsinline: true
        };
        videojs(player, options).ready(function () {
            me.videoPlayer = this;
            me.videoPlayer.muted(false)
            if (!me.videoPlayerState) {
                me.videoPlayerState = "playing";
            }
            me.$(me.options.videoGreetPlayTrigger, me.context).on(
                "click",
                function () {
                    me.handlePlayPause();
                }
            );
            me.$(me.options.videoGreetMuteTrigger, me.context).on(
                "click",
                function () {
                    me.handleVideoGreetMute();
                }
            );
            me.videoPlayer.on("timeupdate", function (data) {
                var currentTime = this.currentTime();
                var duration = this.duration();

                // Calculate the percentage of playtime
                var playtimePercentage = (currentTime / duration) * 100;
                console.log("Video progress", playtimePercentage + "%");
                me.$(me.options.videoGreetSeekbar, me.context).css(
                    "width",
                    playtimePercentage + "%"
                );
                // }
                if (duration - currentTime <= 0.3) {
                    me.resetPlayerAfterVideoEnded();
                }
            });

            me.videoPlayer.on("play", function () {
                console.log("played the video!");
            });

            me.videoPlayer.on("ended", function () {
                // me.onVideoEnded();
            });

            me.$(".apexchat_greet_video_close", me.context).on(
                "click",
                function () {
                    me.handlePlayPause(true);
                    me.$("#apexchat_chat_video_greet_overlay", me.context).hide();
                }
            );
        });
    }
    resetPlayerAfterVideoEnded() {
        var me = this;
        // hack to reset the vimeo player in case of 
        // hiding free account video suggestion
        // checking if the duration of the video is about to end
        // then reset the player, the video will end 100 ms before of it's actual time
        setTimeout(function () {
            me.videoPlayer.currentTime(0);
            me.videoPlayer.pause();
            me.videoPlayerState = 'paused';
            me.$(me.options.videoGreetPlayTrigger, me.context).find(me.options.videoGreetPlayPauseIcon).addClass('play_icon').removeClass('pause_icon');
            me.$(me.options.videoGreetSeekbar, me.context).css('width', 0);
            logIt('▶ Video Greet:: ended');
        }, 200)
    }
    onVideoEnded() {
        var me = this;
        console.log('video ended!');
        me.videoPlayerState = 'paused';
        me.$(me.options.videoGreetPlayTrigger, me.context).find(me.options.videoGreetPlayPauseIcon).toggleClass('play_icon pause_icon');
        me.videoPlayer.pause();
        me.$(me.options.videoGreetSeekbar, me.context).css('width', 0);
    }
    handlePlayPause(pauseOnly) {
        var me = this;
        if (me.videoPlayerState === 'playing' || pauseOnly) {
            me.handlePause();
        }
        else {
            me.$(me.options.videoGreetPlayPauseIcon, me.context).toggleClass('play_icon pause_icon');
            me.videoPlayerState = 'playing';
            me.videoPlayer.play();
            console.log('video resumed');
        }
    }
    handlePause() {
        var me = this;
        me.$(me.options.videoGreetPlayPauseIcon, me.context).addClass('play_icon').removeClass('pause_icon');
        me.videoPlayerState = 'paused';
        me.videoPlayer.pause();
        console.log('video paused');
    }
    handleVideoGreetMute() {
        var me = this;
        if (me.videoPlayer) {
            console.log('video is on mute:' + me.videoPlayer.muted());
            if (me.videoPlayer.muted()) {
                // If the video is muted, unmute it
                me.videoPlayer.muted(false);
                me.replaceMuteIcon(false)
            } else {
                // If the video is not muted, mute it
                me.videoPlayer.muted(true);
                me.replaceMuteIcon(true)
            }
        }
    }
    replaceMuteIcon(muted) {
        var me = this;
        me.$(me.$(me.options.videoGreetMuteTrigger, me.context))
            .find('img').attr('src', 'https://d3b4i635mede5k.cloudfront.net/' + (muted ? 'mute' : 'unmute') + '.png');
        logIt('▶ Video Greet:: icon changed to ' + muted ? 'mute' : 'unmute');
    }

    isEPChatClosed() {
        return ApexChat.storageAPI.Get('livechat_exitpopup_is_closed') === 'true';
    }

    volumeMuteUnmute() {
        const me = this;
        if (getStorageAPIValue(TempCache.CHAT_SOUND_ENABLED) == 'true') {
            ApexChat.storageAPI.Store(TempCache.CHAT_SOUND_ENABLED, false);
        } else {
            ApexChat.storageAPI.Store(TempCache.CHAT_SOUND_ENABLED, true);
        }
    }

    bindRestartChatEvents(el, isDOM) {
        // function for menudropdown ada compliance
        const me = this;
        // el.on('keyup click', (e) => {
        if (!el) {
            return;
        }
        // });
        "keyup click".split(" ").forEach(function (e) {
            el.addEventListener(e, (e) => {
                // check if button already not selected then do the action
                e.stopPropagation();
                if (e.type == 'click' || (e.type == 'keyup' && isAcceptKey(e))) {
                    // check for mouse click or tab and enter key
                    me.restartVAChat();
                    if (isDOM) {
                        me.$(me.actionMenu, me.context).toggle(); // When restart chat overlay is visible then we should hide the action menu.
                    }
                }
            }, false);
        });
    }

    bindTransferChatEvents(el, isDOM) {
        // function for menudropdown ada compliance
        if (!el) {
            return;
        }
        const me = this;
        // el.on('keyup click', (e) => {
        //     // check if button already not selected then do the action
        //     e.stopPropagation();
        //     if (e.type == 'click' || (e.type == 'keyup' && isAcceptKey(e))) {
        //         // check for mouse click or tab and enter key
        //         me.enableChatTransfer();
        //         me.transferChat();
        //         if (isDOM) {
        //             me.$(me.actionMenu, me.context).toggle(); // When restart chat overlay is visible then we should hide the action menu.
        //         }
        //     }
        // });

        "keyup click".split(" ").forEach(function (e) {
            el.addEventListener(e, (e) => {
                // check if button already not selected then do the action
                e.stopPropagation();
                if (e.type == 'click' || (e.type == 'keyup' && isAcceptKey(e))) {
                    // check for mouse click or tab and enter key
                    me.enableChatTransfer().then(_ => {
                        me.transferChat();
                        if (isDOM) {
                            me.$(me.actionMenu, me.context).toggle(); // When restart chat overlay is visible then we should hide the action menu.
                        }
                    })
                }
            }, false);
        });
    }

    toggleLanguageBottomSheet(el) {
        var me = this;
        if (!el) return
        if (!me.switchLang) {
            me.switchLang = new SwitchLanguage(me);
        }

        me.switchLang.toggleLanguageBottomSheet(el, me.$('.open_bottom_sheet', me.context));
    }

    toggleSMSNumberInput(el, payload) { // function for menudropdown ada compliance
        var me = this;
        if (!el) {
            return;
        }
        if (payload) {
            var container = me.$(payload.container, me.context)
            var element = me.$(payload.element, me.context)
            if (element.length > 0) {
                fixedElementToTop(container, element)
            }
        }
        el.forEach(element => {
            "keyup click".split(" ").forEach(function (e) {
                element?.addEventListener(e, (e) => {
                    if ((e.type == 'click' || e.type == 'keyup' && isAcceptKey(e))) { // check for mouse click or tab and enter key
                        me.toggleSmsBottomSheet();
                    }
                });
            })
        })

    }

    createChatRoom(cb) {
        const me = this;
        if (!me.isChatroomAlive()) {
            // if chatroom is not alive and user click on transfer chat option
            me.options.execChatStartHandler(() => {
                me.chatStarted = true;
                logIt('loading chat room on 1st msg...');
                me.loadChatRoom(() => {
                    if (cb && typeof cb === 'function') {
                        cb();
                    }
                });
            });
        }
    }
    showOverlayWithAction(wrapperEl, html, bindEvents, denyDisable) {
        var me = this;
        var messageElement = me.$('#apexchat', me.context)[0];
        if (messageElement) {
            wrapperEl.innerHTML = html;
            messageElement.insertBefore(wrapperEl, messageElement.firstChild);
            if (!denyDisable) {
                disableTypingInput.bind2(me)(me, me.options.inputContainer); //When chat is ended we should disable input feild.
            }
            if (bindEvents) {
                bindEvents();
            }
        }
    }

    showOptInConsentOverlay(m) {
        var me = this;
        var wrapper = document.createElement('div');
        if (!m.options || me.optInConsentTaken) {
            return;
        }

        var acceptText = '',
            rejectText = '',
            changeText = '',
            acceptTextOnSuccess = '',
            rejectTextOnSuccess = '',
            changeTextOnSuccess = '';
        m.options.forEach(function (v) {
            var obj = ApexChat.TryParse(v.option);
            switch (obj.consentType) {
                case 'Accept':
                    acceptText = obj.text;
                    acceptTextOnSuccess = obj.textOnSuccess;
                    break;
                case 'Reject':
                    rejectText = obj.text;
                    rejectTextOnSuccess = obj.textOnSuccess;
                    break;
                case 'Change':
                    changeText = obj.text;
                    changeTextOnSuccess = obj.textOnSuccess;
                    break;
                default:
            }
        });

        me.showOverlayWithAction(
            wrapper,
            me.getOptInConsentHtml(wrapper, { text: m.text, acceptText, rejectText, changeText }),
            function () {
                // add show class to sms opt in parent div
                // after it's been loaded to the dom
                me.$('#livechat_opt_in_consent', me.context).wrap(
                    '<div id="livechat_opt_in_consent_wrapper"></div>'
                );
                RunAsSoonAs(
                    function () {
                        me.$('#livechat_opt_in_consent', me.context).addClass(
                            'apexchat_optin_concent_show'
                        );
                    },
                    function () {
                        return me.$('#livechat_opt_in_consent', me.context).is(':visible');
                    }
                );
                me.ADAHandler(me.context.querySelector('.livechat_optin_agree'), function () {
                    me.optInConsentAccepted(m.id, acceptTextOnSuccess);
                });

                me.$('.livechat_optin_agree', me.context).bind('click', function () {
                    me.optInConsentAccepted(m.id, acceptTextOnSuccess);
                });

                me.ADAHandler(me.context.querySelector('.livechat_optin_change'), function () {
                    me.optInNumberChangeRequested(m.id, changeTextOnSuccess);
                });

                me.$('.livechat_optin_change', me.context).bind('click', function () {
                    me.optInNumberChangeRequested(m.id, changeTextOnSuccess);
                });

                me.ADAHandler(me.context.querySelector('.livechat_optout'), function () {
                    me.optInConsentRejected(m.id, rejectTextOnSuccess);
                });

                me.$('.livechat_optout', me.context).bind('click', function () {
                    me.optInConsentRejected(m.id, rejectTextOnSuccess);
                });
            },
            true
        );
    }
    showWarning(cb) {
        var me = this;
        me.$('.livechat-warning-wrapper', me.context).addClass('livechat-warnin-show');
        if (typeof cb === 'function') {
            cb();
        }
    }

    showDisclaimerOverlay(disclaimerText) {
        var me = this;
        var wrapper = document.createElement('div');
        // if (!m.options || me.disclaimerTaken) {
        //     return;
        // }
        if (Cookies.get(TempCache.USER_REACT_ON_LOC_DISCLAIMER, true)) {
            return;
        }
        var acceptText = 'Yes',
            rejectText = 'No',
            changeText = '',
            acceptTextOnSuccess = '',
            rejectTextOnSuccess = '',
            changeTextOnSuccess = '',
            decliningBoxText =
                'Without your consent, the chat will conclude. Would you like to provide consent and continue the chat?',
            text = disclaimerText;
        me.showOverlayWithAction(
            wrapper,
            me.getDisclaimerHtml(wrapper, {
                text,
                decliningBoxText,
                acceptText,
                rejectText,
                changeText
            }),
            function () {
                // add show class to sms opt in parent div
                // after it's been loaded to the dom

                me.$('#livechat_disclaimer_consent', me.context).wrap(
                    '<div id="livechat_disclaimer_consent_wrapper" class="livechat_overlay_sheet_wrapper livechat_overlay_sheet_wrapper"></div>'
                );
                RunAsSoonAs(
                    function () {
                        me.$('#livechat_disclaimer_consent', me.context).addClass(
                            'apexchat_disclaimer_show'
                        );
                        me.$('.livechat_consent_warning', me.context).on('click', function () {
                            me.$(this).parents('.apexchat_overlay_content').hide();
                            me.showWarning();
                        });
                    },
                    function () {
                        return me.context.querySelector('#livechat_disclaimer_consent')?.style.display !== 'none'
                    }
                );
                var agreeButtons = me.context.querySelectorAll('.livechat_consent_agree');
                agreeButtons.forEach(button => {
                    me.ADAHandler(button, function () {
                        me.disclaimerAccepted(1);
                    });

                    button.addEventListener('click', function () {
                        me.disclaimerAccepted(1);
                    });
                })


                me.ADAHandler(me.context.querySelector('.livechat_consent_deny'), function () {
                    me.disclaimerRejected(2);
                });

                me.context.querySelector('.livechat_consent_deny').addEventListener('click', function () {
                    me.disclaimerRejected(2);
                });
            },
            true
        );
    }

    removeOptInConsentOverlay() {
        var me = this;
        me.$('#livechat_opt_in_consent', me.context).removeClass('apexchat_optin_concent_show');
        setTimeout(() => {
            me.$('#livechat_opt_in_consent', me.context).remove();
            me.$('#livechat_opt_in_consent_wrapper', me.context).remove();
        }, 500)

    }

    removeDisclaimerOverlay() {
        var me = this;
        me.$('#livechat_disclaimer_consent', me.context).removeClass('apexchat_optin_concent_show');

        setTimeout(() => {
            me.$('#livechat_disclaimer_consent', me.context).remove();
        }, 500)
    }

    optInConsentAccepted(chatLogId, postText) {
        var me = this;
        me.optInConsentTaken = true;
        me.sendMessage(me.$(me.messageInput, me.context));
        me.postMessage({
            event: ChatEvents.OnChatOptInConsentAccepted,
            data: {
                chatId: me.getChatId(),
                consentGiven: me.optInConsentTaken,
                chatLogId: chatLogId,
                textOnSuccess: postText
            }
        });
        me.removeOptInConsentOverlay();
    }

    optInConsentRejected(chatLogId, postText) {
        var me = this;
        me.optInConsentTaken = false;
        me.sendMessage(me.$(me.messageInput, me.context));
        me.postMessage({
            event: ChatEvents.OnChatOptInConsentRejected,
            data: {
                chatId: me.getChatId(),
                consentGiven: me.optInConsentTaken,
                chatLogId: chatLogId,
                textOnSuccess: postText
            }
        });
        me.removeOptInConsentOverlay();
    }

    disclaimerAccepted(postAction) {
        var me = this;
        me.disclaimerTaken = true;
        setTimeout(() => {
            me.$('#livechat_disclaimer_consent_wrapper', me.context).hide();
        }, 500)
        RunAsSoonAs(
            function () {
                Cookies.set(TempCache.USER_REACT_ON_LOC_DISCLAIMER, true);
                me.postMessage({
                    event: ChatEvents.OnChatDisclaimerAccepted,
                    data: { chatId: me.getChatId(), action: postAction }
                });
            },
            function () {
                return typeof me.getChatId() !== 'undefined';
            }
        );
        me.removeDisclaimerOverlay();
    }

    disclaimerRejected(postAction) {
        var me = this;
        me.$('#livechat_disclaimer_consent', me.context).css('cursor', 'wait');
        me.disclaimerTaken = true;
        setTimeout(() => {
            me.$('#livechat_disclaimer_consent_wrapper', me.context).hide();
        }, 500)
        RunAsSoonAs(
            function () {
                Cookies.set(TempCache.USER_REACT_ON_LOC_DISCLAIMER, true);
                me.postMessage({
                    event: ChatEvents.OnChatDisclaimerRejected,
                    data: { chatId: me.getChatId(), action: postAction }
                });
            },
            function () {
                return typeof me.getChatId() !== 'undefined';
            }
        );
        me.removeDisclaimerOverlay();
        me.removeOptInConsentOverlay();
    }

    optInNumberChangeRequested(chatLogId, postText) {
        var me = this;
        me.$(me.messageInput, me.context).val('').focus();
        me.postMessage({
            event: ChatEvents.OnChatOptInConsentAcceptedButNumberChangeRequested,
            data: {
                chatId: me.getChatId(),
                consentGiven: me.optInConsentTaken,
                chatLogId: chatLogId,
                textOnSuccess: postText,
                changeRequested: true
            }
        });
        me.removeOptInConsentOverlay();
    }
    /**
     * Handles the Date of Birth (DOB) message by disabling pointer events
     * for the previous BottomSheet DOB input element in the chat log.
     * and if a previous DOB input element is found, it sets its pointer
     * events to 'none' after a delay. This ensures that the element is
     * no longer interactive.
     */
    handleDateTimeDOBMessage() {
        var me = this;
        try {
            const chatLogLength = me.chatLogArray?.length;
            if (chatLogLength) {
                const uniqChatArray = getUniqueValueArray(me.chatLogArray, "id")
                const previousMsg = uniqChatArray[uniqChatArray.length - 2];
                if (previousMsg) {
                    setTimeout(() => {
                        const prevBottomSheetDOBInput = me.context.querySelector(`#livechat_qt_dob_input_${previousMsg.id}`)
                        if (prevBottomSheetDOBInput) {
                            prevBottomSheetDOBInput.style.pointerEvents = 'none';
                        }
                    }, 1000); // wait for chat UI to be loaded
                }
            }
        } catch (error) {
            console.error(error)
        }
    }

    handleAttachmentButtonClicked() {
        const me = this;
        me.fileUploader.initUploadTrigger('livechat_send_attachments_button')
        me.fileUploadEmitter.on('upload:error', (errorMessage) => {
            console.error('Upload error:', errorMessage);
        });
        me.fileUploadEmitter.on('upload:success', (files) => {
            console.log('Upload success!', files);
            me.fileUploadTrigger?.style?.display = "none";
            me.fileUploader.clearUploads(me.context);
        });
    }

    handleAttachmentButtonVisibility(message) {
        const me = this;
        if (message.questionType == ScriptsQuestionType.FullText) {
            me.fileUploadTrigger?.style?.display = "block";
        } else {
            me.fileUploadTrigger?.style?.display = "none";
        }
    }
}
